/**
 * Українська.
 *
 * Ключі походять із `cs.js`. Якщо якогось бракує, показується англійський
 * текст (а як і його немає — чеський), щоб пропуск було видно.
 *
 * Цей переклад ще не читала жодна транс-людина, яка говорить українською.
 * Словник переходу і звертання тут важать більше, ніж деінде: якщо щось
 * звучить не так, скажіть, і ми змінимо.
 */
import { tvary } from '../lib/mnozne';

const uk = {

  // ── společné ──────────────────────────────────────────────────────────────
  'obecne.zpet': 'Назад',
  'obecne.hledat': 'Пошук',
  'obecne.nacitani': 'Завантаження…',
  'obecne.zrusit': 'Скасувати',
  'obecne.ulozit': 'Зберегти',
  'obecne.odeslat': 'Надіслати',
  'obecne.vice': 'Показати все',
  'obecne.jazyk': 'Мова',

  // ── přihlášení a registrace ───────────────────────────────────────────────
  'auth.podtitulek': 'Безпечний простір для транс-спільноти, де можна говорити відверто, шукати допомогу й відчувати підтримку інших.',
  'auth.prihlaseni': 'Увійти',
  'auth.registrace': 'Реєстрація',
  'auth.email': 'Е-пошта',
  'auth.heslo': 'Пароль',
  'auth.emailPriklad': 'ty@pryklad.ua',
  'auth.prihlasitSe': 'Увійти',
  'auth.prihlasuji': 'Вхід…',
  'auth.zapomenuteHeslo': 'Забули пароль?',
  'auth.presGoogle': 'Увійти через Google',
  'auth.spatneUdaje': 'Неправильна пошта або пароль',
  'auth.uspech': 'Вхід виконано.',
  'auth.googleChyba': 'Не вдалося увійти через Google',
  'auth.obnoveniHesla': 'Відновлення пароля',
  'auth.obnoveniOdeslano': 'Якщо ця пошта зареєстрована, ви отримаєте посилання для зміни пароля.',
  'auth.zpetNaPrihlaseni': 'Назад до входу',
  'auth.odeslatOdkaz': 'Надіслати посилання',
  'auth.obnoveniChyba': 'Не вдалося надіслати лист. Спробуйте ще раз.',

  // druhý krok přihlášení
  'auth.jesteKod': 'Ще один крок: ваш код',
  'auth.jesteKodPopis': 'Відкрийте застосунок автентифікації та перепишіть шість цифр, які він показує для Bloom.',
  'auth.kod': 'Код',
  'auth.zalozniKodNapoveda': 'Телефона немає під рукою? Введіть один із резервних кодів, які ви зберегли під час увімкнення.',
  'auth.potvrdit': 'Підтвердити',
  'auth.overuji': 'Перевіряємо…',
  'auth.kodNesedi': 'Цей код не підходить',
  'auth.zalozniDochazeji': (p) => `Залишилося лише ${p.pocet} резервних кодів. Згенеруйте нові у профілі.`,

  // instalace a zabezpečení
  'auth.instalaceTitulek': 'Як встановити Bloom на телефон',
  'auth.krokyAndroid': [
      'Відкрийте цю сторінку в Chrome',
      'Натисніть значок трьох крапок (⋮) у правому верхньому куті',
      'Виберіть «Додати на головний екран» або «Встановити застосунок»',
      'Підтвердьте встановлення',
    ],
  'auth.krokyIos': [
      'Відкрийте цю сторінку в Safari',
      'Натисніть значок поділитися (□↑) на нижній панелі',
      'Прокрутіть униз і виберіть «На початковий екран»',
      'Підтвердьте, натиснувши «Додати»',
    ],
  'auth.seznamChranene': [
      { silne: 'Про учасниць і учасників нічого не є публічним.', text: 'Профілі, історії, пропозиції, запитання, фото й аватари бачать лише ті, хто увійшов. Нічого з цього не можна завантажити чи зібрати без облікового запису.' },
      { silne: 'Ніхто не знає вашого пароля', text: '— ми теж ні. Зберігається лише відбиток bcrypt, з якого оригінал не відновити.' },
      { silne: 'Приватні повідомлення й вкладення зашифровані', text: '(AES + перевірка цілісності) вже на диску сервера. Хто отримав би резервну копію чи диск, прочитав би лише беззмістовні символи.' },
      { silne: 'Повідомлення видаляються самі', text: 'через певний час (типово 90 днів), разом із голосовими та фото. Те, чого тут немає, не витече.' },
      { silne: 'Ваш етап трансгендерного переходу приватний', text: 'доки ви самі його не опублікуєте. Кроки, які ви позначаєте у Провіднику, бачите тільки ви.' },
      { silne: 'Пошта й телефон', text: 'ніколи не показуються іншим людям.' },
      { silne: '', text: 'Вхід захищений від підбору пароля: кількість спроб обмежена.' },
      { silne: 'Наскрізне шифрування повідомлень.', text: 'Коли ви його вмикаєте, текст і вкладення шифруються у вашому власному браузері, а сервер отримує лише нечитабельні символи. Ключ відкривається вашим паролем і ніколи не залишає ваш пристрій — тому й ми не прочитаємо вміст, навіть якби його вимагав суд. Ціна така: якщо ви забудете пароль, старі повідомлення не прочитаєте й ви.' },
      { silne: '', text: 'Вхід не триває нескінченно: Bloom виходить із облікового запису, коли ви закриваєте вікно, і після десяти хвилин без дії.' },
    ],
  'auth.seznamNeumime': [
      { silne: 'Метадані', text: '— хто кому й коли написав — сервер має знати, щоб доставити повідомлення. Наскрізне шифрування цього не приховає, Signal теж ні.' },
      { silne: '', text: 'Bloom — вебзастосунок, тож щоразу під час відкриття завантажує код шифрування з нашого сервера. Хто заволодів би сервером, теоретично міг би підсунути змінений код. Від цього захищає лише підписаний застосунок із магазину — тому Signal його має, а вебверсія ні.' },
      { silne: 'Профілі', text: '— псевдонім, опис, аватар — зашифрувати не можна, бо сервер має показувати їх іншим.' },
      { silne: '', text: 'Повідомлення до ввімкнення шифрування залишаються зашифрованими лише на диску сервера, а не наскрізно.' },
    ],
  'auth.instalaceAndroid': 'Android',
  'auth.instalaceIos': 'iPhone / iPad',
  'auth.instalacePoznamka': 'Bloom працює як застосунок, навіть без інтернету. Ваші дані завжди актуальні.',
  'auth.zabezpeceniTitulek': 'Як захищений Bloom',
  'auth.zabezpeceniUvod': 'Bloom — простір для транс-спільноти, тож тут зустрічаються делікатні речі. Нижче те, що '
      + 'ми робимо для їх захисту — і чого не вміємо — без прикрас.',
  'auth.coJeChranene': 'Що захищено',
  'auth.coNeumime': 'Чого Bloom не вміє — і чесно про це каже',
  'auth.zabezpeceniZaver': 'Якщо у вас є питання про приватність або ви знайшли вразливість, скористайтеся кнопкою «Повідомити про проблему» нижче. Ми ставимося до цього серйозно.',
  'auth.mvp': 'Bloom у першій версії, і ми покращуємо його разом зі спільнотою. '
      + 'Якщо натрапите на помилку або матимете ідею, будемо раді дізнатися.',
  'auth.nahlasitProblem': 'Повідомити про проблему',
  'auth.clenu': (p) => tvary('uk', p.pocet, { one: 'людина', few: 'людини', many: 'людей', other: 'людей' }),
  'auth.prispevku': (p) => tvary('uk', p.pocet, { one: 'допис', few: 'дописи', many: 'дописів', other: 'дописів' }),
  'auth.odborniku': (p) => tvary('uk', p.pocet, { one: 'фахівець', few: 'фахівці', many: 'фахівців', other: 'фахівців' }),
  'auth.nabidek': (p) => tvary('uk', p.pocet, { one: 'пропозиція', few: 'пропозиції', many: 'пропозицій', other: 'пропозицій' }),

  // ── registrace ────────────────────────────────────────────────────────────
  'reg.prezdivka': 'Псевдонім (унікальний)',
  'reg.prezdivkaPriklad': 'Щонайменше 3 символи',
  'reg.telefon': 'Телефон',
  'reg.volitelne': '(необовʼязково)',
  'reg.heslo': 'Пароль',
  'reg.hesloZnovu': 'Повторіть пароль',
  'reg.zajmeno': 'Займенники',
  'reg.oMne': 'Про мене',
  'reg.oMnePriklad': 'Кілька слів про себе…',
  'reg.registrovat': 'Створити обліковий запис',
  'reg.registruji': 'Створюємо обліковий запис…',
  'reg.presGoogle': 'Зареєструватися через Google',
  'reg.avatar': 'Аватар',
  'reg.neboFoto': 'Або завантажте власне фото',
  'reg.nahratFoto': 'Завантажити фото',
  'reg.vlastni': 'Власне',
  'reg.zeme': 'Країна',
  'reg.kraj': 'Регіон',
  'reg.nechciUvadet': 'Волію не вказувати',
  'reg.cesko': 'Чехія',
  'reg.svet': 'Решта світу',

  // skupiny avatarů
  'reg.avatarFem': 'Жіночі',
  'reg.avatarMask': 'Чоловічі',
  'reg.avatarNeutr': 'Нейтральні',
  'reg.avatarZvirata': 'Тварини',

  // komunitní heslo
  'reg.komunitniHeslo': 'Пароль спільноти',
  'reg.komunitniHesloPriklad': 'Введіть пароль спільноти…',
  'reg.komunitniHesloPopis': 'Bloom — приватний простір для транс-спільноти. Пароль вам може дати хтось зі спільноти.',
  'reg.napisAdminovi': 'Якщо ви нікого не знаєте, напишіть адміністрації на',
  'reg.nevimHeslo': 'Я не знаю пароля спільноти',
  'reg.jakZiskat': 'Пароль спільноти захищає цей приватний простір. Як його отримати:',
  'reg.krok1': '1. Напишіть листа на',
  'reg.krok2': '2. Коротко представтеся й скажіть, звідки дізналися про Bloom',
  'reg.krok3': '3. Адміністрація відповість якнайшвидше',

  // kontrola hesla
  'reg.hesloKratke': 'Пароль має містити щонайменше 8 символів',
  'reg.hesloMale': 'Пароль має містити малу літеру',
  'reg.hesloVelke': 'Пароль має містити велику літеру',
  'reg.hesloCislo': 'Пароль має містити цифру',
  'reg.hesloZnak': 'Пароль має містити спеціальний символ (!@#$%…)',
  'reg.pozadavek8': 'Щонайменше 8 символів',
  'reg.pozadavekVelke': 'Велика літера',
  'reg.pozadavekCislo': 'Цифра',
  'reg.pozadavekZnak': 'Спеціальний символ (!@#$%)',
  'reg.hesloNesouhlasi': 'Паролі не збігаються',
  'reg.prezdivkaKratka': 'Псевдонім має містити щонайменше 3 символи',
  'reg.hesloPovinne': 'Пароль спільноти обовʼязковий',
  'reg.hotovo': 'Обліковий запис створено. Перевірте пошту, щоб його підтвердити.',
  'reg.fotoVelka': 'Зображення завелике (макс. 2 МБ)',
  'reg.chyba': 'Не вдалося створити обліковий запис',

  // ── domovská stránka ──────────────────────────────────────────────────────
  'domu.citat': 'Тут ніхто не мусить бути ідеальним. Bloom — простір, де кожна людина може бути собою — '
      + 'де можна ділитися досвідом, питати й допомагати іншим. Без осуду й без упереджень.',
  'domu.citatAutor': '— Martina Sobková',
  'domu.prelozenoZCestiny': ' · перекладено з чеської',
  'domu.vitej': 'Вітаємо,',
  'domu.vCislech': 'Bloom у цифрах',
  'domu.noveVKomunite': 'Уперше тут?',
  'domu.noveVKomunitePopis1': 'Не обовʼязково бути на видноті. Не потрібне фото. Не обовʼязково бути відкрито собою.',
  'domu.noveVKomunitePopis2': 'Bloom — простір, де можна починати у своєму темпі.',
  'domu.rozcestnik1': 'Я тут уперше',
  'domu.rozcestnik2': 'Не знаю, з чого почати',
  'domu.rozcestnik3': 'Хочу лишитися анонімно',
  'domu.rozcestnik4': 'Шукаю фахівців',
  'domu.rozcestnik5': 'Хочу просто почитати досвід інших',
  'domu.otazky': 'Є питання або хочете знати більше? Напишіть нам на',
  'domu.doporucujeme': 'Радимо',
  'domu.odbornici': 'Фахівці',
  'domu.noviClenove': 'Нові люди у спільноті',
  'domu.zadniNovi': 'Поки нікого нового',
  'domu.nejnovejsiOtazky': 'Найновіші запитання',
  'domu.zadneOtazky': 'Поки що немає запитань.',
  'domu.nejlepeHodnoceni': 'Найкраще оцінені фахівці',
  'domu.zadniHodnoceni': 'Поки що немає оцінок',
  'domu.zadneAktuality': 'Поки що немає новин',

  // dlaždice sekcí
  'domu.dlazdice.support': 'Запропонуйте те, що вмієте, і отримайте допомогу від інших.',
  'domu.dlazdice.specialists': 'Знайдіть перевірених фахівців — від психології до пластичної хірургії.',
  'domu.dlazdice.legal': 'Правова допомога, статті та відповіді на ваші запитання.',
  'domu.dlazdice.nearby': 'Послуги та фахівці поблизу вас.',

  // počty
  'domu.pocetClenu': (p) => tvary('uk', p.pocet, { one: 'людина у спільноті', few: 'людини у спільноті', many: 'людей у спільноті', other: 'людей у спільноті' }),
  'domu.pocetZkusenosti': (p) => tvary('uk', p.pocet, { one: 'описаний досвід', few: 'описані досвіди', many: 'описаних досвідів', other: 'описаних досвідів' }),
  'domu.pocetOdborniku': (p) => tvary('uk', p.pocet, { one: 'перевірений фахівець', few: 'перевірені фахівці', many: 'перевірених фахівців', other: 'перевірених фахівців' }),
  'domu.pocetNabidek': (p) => tvary('uk', p.pocet, { one: 'пропозиція підтримки', few: 'пропозиції підтримки', many: 'пропозицій підтримки', other: 'пропозицій підтримки' }),

  // ── navigace a společné ovládání ──────────────────────────────────────────
  'nav.domu': 'Головна',
  'nav.news': 'Новини',
  'nav.stories': 'Досвід спільноти',
  'nav.mapaSveta': 'Карта світу',
  'nav.support': 'Взаємна допомога',
  'nav.specialists': 'Транс-дружні фахівці',
  'nav.legal': 'Правова допомога',
  'nav.pageants': 'Конкурси',
  'nav.nearby': 'Поруч зі мною',
  'nav.hledat': 'Пошук у Bloom',
  'nav.hledatPlaceholder': 'Шукати людей, фахівців, статті…',
  'nav.zpravy': 'Повідомлення',
  'nav.profil': 'Мій профіль',
  'nav.mojeCesta': 'Мій шлях',
  'nav.administrace': 'Адміністрування',
  'nav.odhlasit': 'Вийти',
  'nav.vsechnyVysledky': (p) => `Показати всі результати за «${p.dotaz}»`,
  'nav.overEmail': 'Підтвердьте свою пошту',
  'nav.menu': 'Меню',

  // ── mapa světa ────────────────────────────────────────────────────────────
  'svet.titulek': 'Bloom у світі',
  'svet.podtitulek': 'Виберіть країну й подивіться, що спільнота там зібрала.',
  'svet.hledatZemi': 'Шукати країну…',
  'svet.vsechnyZeme': 'Усі країни',
  'svet.jenSObsahem': 'Лише країни з вмістом',
  'svet.nicNenalezeno': 'Жодна країна не підходить.',
  'svet.zaznamu': (p) => `${p.pocet} ${tvary('uk', p.pocet, { one: 'запис', few: 'записи', many: 'записів', other: 'записів' })}`,
  'svet.prazdnaZeme': 'Поки нічого',
  'svet.kontinent': 'Континент',
  'svet.celySvet': 'Увесь світ',
  'svet.vse': 'Усе',
  'svet.zacniDomovem': 'Почніть із вибору країни, де ви живете. Її також можна вибрати зі списку під картою.',
  'svet.zkoumej': 'Виберіть країну й подивіться, що Bloom там має. Дивитися можна будь-де — '
      + 'вашої країни це не змінить.',
  'svet.domov': 'Дім',
  'svet.zrusitDomov': 'Прибрати країну проживання',
  'svet.nastavitDomov': 'Зробити моєю країною',
  'svet.zeSveta': 'Зі світу',
  'svet.coSeChysta': 'Що готується',
  'svet.souteze': 'Конкурси з відкритою реєстрацією',
  'svet.noveOrganizace': 'Нові організації',
  'svet.kdeJizNeco': 'Де Bloom уже щось має',
  'svet.hledatZemiPopisek': 'Шукати країну',
  'svet.nicNeodpovida': 'Нічого не знайдено. Спробуйте інакше.',
  'svet.napovedaKMape': 'Перетягуйте карту, щоб її рухати, і наближайте колесом чи кнопками. Користуватися нею '
      + 'не обовʼязково — пошук і повний список країн нижче.',
  'svet.tvujBloom': (p) => `Ваш Bloom у країні ${p.zeme}`,
  'svet.tvojeDomovska': 'ваша країна проживання',
  'svet.zemi': (p) => `${p.pocet} ${tvary('uk', p.pocet, { one: 'країна', few: 'країни', many: 'країн', other: 'країн' })}`,
  'svet.chyba': 'Не вдалося завантажити країни. Перезавантажте сторінку.',
  'svet.pocet.specialists': (p) => `${p.pocet} ${tvary('uk', p.pocet, { one: 'фахівець', few: 'фахівці', many: 'фахівців', other: 'фахівців' })}`,
  'svet.pocet.organizations': (p) => `${p.pocet} ${tvary('uk', p.pocet, { one: 'організація', few: 'організації', many: 'організацій', other: 'організацій' })}`,
  'svet.pocet.events': (p) => `${p.pocet} ${tvary('uk', p.pocet, { one: 'подія', few: 'події', many: 'подій', other: 'подій' })}`,
  'svet.pocet.pageants': (p) => `${p.pocet} ${tvary('uk', p.pocet, { one: 'конкурс', few: 'конкурси', many: 'конкурсів', other: 'конкурсів' })}`,
  'svet.pocet.resources': (p) => `${p.pocet} ${tvary('uk', p.pocet, { one: 'матеріал', few: 'матеріали', many: 'матеріалів', other: 'матеріалів' })}`,

  // světadíly
  'kontinent.europe': 'Європа',
  'kontinent.asia': 'Азія',
  'kontinent.africa': 'Африка',
  'kontinent.north_america': 'Північна Америка',
  'kontinent.south_america': 'Південна Америка',
  'kontinent.oceania': 'Океанія',
  'kontinent.antarctica': 'Антарктида',

  // ── soutěže napříč světem ─────────────────────────────────────────────────
  'souteze.podtitulek': 'Транс-конкурси з усього світу. Ті, на які ще можна податися, — угорі.',
  'souteze.hledat': 'Шукати конкурс…',
  'souteze.zadne': 'Конкурсів поки немає. Знаєте якийсь? Надішліть пропозицію.',

  // ── náhled země pod mapou ─────────────────────────────────────────────────
  'nahled.otevrit': (p) => `Відкрити: ${p.zeme}`,
  'nahled.zavrit': 'Закрити попередній перегляд',
  'nahled.jenInformace': 'Поки що маємо лише інформацію про країну.',
  'nahled.zatimNic': 'Тут поки що немає контактів, організацій чи подій. Щось знаєте? Надішліть пропозицію.',
  // ── stránka země ──────────────────────────────────────────────────────────
  'zeme.titulek': (p) => `Bloom: ${p.zeme}`,
  'zeme.podtitulek': (p) => `Що спільнота зібрала в країні ${p.zeme}.`,
  'zeme.prazdna': 'Bloom тут лише починає. Ви можете стати першою людиною, яка щось додасть.',
  'zeme.mapaSveta': 'Карта світу',
  'zeme.navrhnout': 'Запропонувати запис',
  'zeme.domovska': 'Ваша країна проживання',
  'zeme.nastavitDomovskou': 'Зробити моєю країною',
  'zeme.kdeToJe': 'Де це знайти',
  'zeme.coTuBude': 'Що ви тут знайдете',
  'zeme.zatimPrazdne': 'поки порожньо',
  'zeme.pripravujeme': 'у підготовці',
  'zeme.zobrazitVse': (p) => `Показати все (${p.pocet})`,
  'zeme.rosteTitulek': 'Bloom тут лише росте',
  'zeme.rostePopis': 'Тут поки що нічого немає. Знаєте організацію, подію чи корисний '
      + 'контакт? Надішліть пропозицію — вона пройде перевірку і потім зʼявиться тут.',
  'zeme.jinouZemi': 'Переглянути інші країни',
  'zeme.bezKontaktu': 'Тут поки що немає контактів чи організацій.',
  'zeme.bezKontaktuPopis': 'Знаєте тут когось чи щось корисне? Надішліть пропозицію — вона пройде '
      + 'перевірку і потім зʼявиться тут.',
  'zeme.neznama': 'Такої країни ми не знаємо.',
  'zeme.chyba': 'Не вдалося завантажити країну.',

  // ── sekce ─────────────────────────────────────────────────────────────────
  'sekce.specialists': 'Кабінети та клініки',
  'sekce.specialists.popis': 'Лікарі, клініки та інші фахівці, з якими спільнота має досвід.',
  'sekce.organizations': 'Організації',
  'sekce.organizations.popis': 'Обʼєднання, неприбуткові організації та групи підтримки.',
  'sekce.events': 'Події',
  'sekce.events.popis': 'Зустрічі, прайди, воркшопи та конференції.',
  'sekce.pageants': 'Конкурси',
  'sekce.pageants.popis': 'Транс-конкурси та їхні дати.',
  'sekce.resources': 'Матеріали',
  'sekce.resources.popis': 'Практична інформація про цю країну.',
  'sekce.community': 'Спільнота',
  'sekce.community.popis': 'Люди та групи в цій країні.',
  'sekce.legal': 'Правова допомога',
  'sekce.legal.popis': 'Інформація та підтримка для транс-спільноти',
  'sekce.support': 'Взаємна допомога',
  'sekce.support.popis': 'Запропонуйте те, що вмієте, і отримайте допомогу від інших людей зі спільноти',

  // ── výpis záznamů ─────────────────────────────────────────────────────────
  'vypis.hledatVZemi': 'Шукати в цій країні…',
  'vypis.vsechnyKategorie': 'Усі категорії',
  'vypis.kategorie': 'Категорія',
  'vypis.celaZeme': 'Уся країна',
  'vypis.navrhnout': 'Запропонувати',
  'vypis.nicNeodpovida': 'Нічого не знайдено. Спробуйте інакше або зніміть фільтр.',
  'vypis.zadneZaznamy': (p) => `У країні ${p.zeme} записів поки немає.`,
  'vypis.zaznamu': (p) => `${p.pocet} ${tvary('uk', p.pocet, { one: 'запис', few: 'записи', many: 'записів', other: 'записів' })}`,
  'vypis.predchozi': 'Назад',
  'vypis.dalsi': 'Далі',
  'vypis.chyba': 'Не вдалося завантажити записи.',
  'vypis.neznamyDruh': 'Такого виду записів ми не знаємо.',

  // ── detail záznamu ────────────────────────────────────────────────────────
  'detail.zpetNa': (p) => `Назад: ${p.zeme}`,
  'detail.kontakty': 'Контакти й посилання',
  'detail.podrobnosti': 'Подробиці',
  'detail.zacatek': 'Початок',
  'detail.termin': 'Дата',
  'detail.uzaverka': 'Кінцевий термін заявок',
  'detail.prihlaska': 'Заявка',
  'detail.strankaAkce': 'Сторінка події',
  'detail.web': 'Сайт',
  'detail.konec': 'Кінець',
  'detail.stavRocniku': 'Стан цьогорічного конкурсу',
  'detail.oblasti': 'Напрями діяльності',
  'detail.coNabizi': 'Що пропонують',
  'detail.kategorie': 'Категорії',
  'detail.jazyky': 'Мови',
  'detail.vitezove': 'Попередні переможниці',
  'detail.kdoSeMuze': 'Хто може взяти участь',
  'detail.poradatel': 'Організація',
  'detail.poplatek': 'Внесок',
  'detail.tema': 'Тема',
  'detail.forma.offline': 'Наживо',
  'detail.forma.online': 'Онлайн',
  'detail.forma.hybrid': 'Наживо й онлайн',
  'detail.rozsah.local': 'Місцевий',
  'detail.rozsah.national': 'Загальнонаціональний',
  'detail.rozsah.international': 'Міжнародний',
  'detail.rocnik.upcoming': 'Готується',
  'detail.rocnik.registration_open': 'Заявки відкриті',
  'detail.rocnik.registration_closed': 'Заявки закриті',
  'detail.rocnik.completed': 'Відбувся',
  'detail.zdroj': (p) => `Джерело: ${p.zdroj}`,
  'detail.upraveno': (p) => `Востаннє змінено: ${p.datum}`,
  'detail.overeno': 'Перевірено, що запис відповідає дійсності. Це не рекомендація від Bloom.',
  'detail.neovereno': 'Цей запис ще не перевірено. Дані могли змінитися — звірте з джерелом.',
  'detail.nenalezen': 'Такого запису ми не знаємо. Можливо, його видалили або він ще чекає на перевірку.',
  'detail.chyba': 'Не вдалося завантажити запис.',

  // ── profil země ───────────────────────────────────────────────────────────
  'profil.coTuPlati': 'Що тут діє',
  'profil.name_change': 'Зміна імені',
  'profil.gender_marker': 'Зміна статі в документах',
  'profil.surgery_required': 'Чи потрібна операція',
  'profil.healthcare': 'Доступ до медичної допомоги',
  'profil.legal_protection': 'Захист від дискримінації',
  'profil.safety': 'Безпека',
  'profil.stav.yes': 'Так',
  'profil.stav.limited': 'Частково',
  'profil.stav.no': 'Ні',
  'profil.stav.unknown': 'Немає даних',
  'profil.zdroj': 'Джерело',
  'profil.zdrojZRoku': (p) => `джерело за ${p.rok}`,
  'profil.overeno': (p) => `Перевірено ${p.datum}`,
  'profil.zmena': 'Остання зміна',
  'profil.odKdy': (p) => `діє з ${p.datum}`,
  'profil.doklady': 'Джерела',
  'profil.zakon': 'закон або рішення суду',
  'profil.upozorneni': 'Це не юридична консультація. Закони змінюються, і багато залежить від вашої '
      + 'конкретної ситуації — звірте з джерелом або з організацією в тій '
      + 'країні, перш ніж діяти.',

  // ── formulář návrhu ───────────────────────────────────────────────────────
  'navrh.titulek': (p) => `Запропонувати ${p.druh}${p.zeme ? ` — ${p.zeme}` : ''}`,
  'navrh.popisFormulare': 'Ваша пропозиція проходить перевірку, перш ніж зʼявитися в Bloom. Заповніть те, що '
      + 'знаєте — решту доповнимо ми.',
  'navrh.jednotne.organizations': 'організацію',
  'navrh.jednotne.events': 'подію',
  'navrh.jednotne.pageants': 'конкурс',
  'navrh.jednotne.resources': 'матеріал',
  'navrh.popis.organizations': 'Обʼєднання, неприбуткова організація чи група підтримки.',
  'navrh.popis.events': 'Зустріч, прайд, воркшоп, конференція.',
  'navrh.popis.pageants': 'Транс-конкурс — дата, заявки, хто організовує.',
  'navrh.popis.resources': 'Практична інформація — здоровʼя, право, документи, контакти.',
  'navrh.nazev': 'Назва',
  'navrh.popisPole': 'Опис',
  'navrh.zeme': 'Країна',
  'navrh.mesto': 'Місто',
  'navrh.adresa': 'Адреса',
  'navrh.web': 'Сайт',
  'navrh.email': 'Е-пошта',
  'navrh.telefon': 'Телефон',
  'navrh.odkudVis': 'Звідки ви це знаєте',
  'navrh.odkudVisPriklad': 'напр. з їхнього сайту, я там була…',
  'navrh.vyberte': '— виберіть —',
  'navrh.forma': 'Формат',
  'navrh.rozsah': 'Масштаб',
  'navrh.platiPro': 'Стосується',
  'navrh.platnost.global': 'Усього світу',
  'navrh.platnost.country': 'Країни',
  'navrh.platnost.region': 'Регіону',
  'navrh.platnost.city': 'Міста',
  'navrh.odkazAkce': 'Посилання на подію',
  'navrh.odkazPrihlaska': 'Посилання на заявку',
  'navrh.odkazy': 'Посилання',
  'navrh.text': 'Текст',
  'navrh.odeslat': 'Надіслати пропозицію',
  'navrh.odesilam': 'Надсилаємо…',
  'navrh.chyba': 'Не вдалося надіслати пропозицію',
  'navrh.dikyTitulek': 'Дякуємо, ми це маємо',
  'navrh.dikyPopis': 'Ми отримали вашу пропозицію. Хтось її перегляне, і тоді вона зʼявиться '
      + 'в Bloom. Нічого не публікується автоматично.',
  'navrh.zavrit': 'Закрити',
  'navrh.seznamNapoveda': 'Розділяйте пункти комами.',

  // ── převzetí profilu ──────────────────────────────────────────────────────
  'prevzeti.patriVam': (p) => `Це ${p.druh} — ваша?`,
  'prevzeti.popis': 'Ви можете взяти профіль на себе й тримати дані актуальними. '
      + 'Запит спершу проходить перевірку.',
  'prevzeti.tlacitko': 'Взяти цей профіль на себе',
  'prevzeti.spravujes': 'Ви керуєте цим профілем. Дані можна виправляти будь-коли — зміни діють одразу.',
  'prevzeti.upravit': 'Редагувати дані',
  'prevzeti.spravujeSama': (p) => `Цим профілем керує сама ${p.druh}.`,
  'prevzeti.ceka': 'Ми отримали ваш запит і розглядаємо його.',
  'prevzeti.formulacTitulek': (p) => `Взяти профіль на себе — ${p.nazev}`,
  'prevzeti.formulacPopis': 'Перш ніж передати профіль, нам треба знати, що ви справді належите до цієї '
      + 'організації. Запит проходить перевірку; поки що нічого не змінюється.',
  'prevzeti.role': 'Яка ваша роль там?',
  'prevzeti.rolePriklad': 'напр. координація, голова обʼєднання',
  'prevzeti.doklad': 'Як ми можемо це перевірити?',
  'prevzeti.dokladPriklad': 'напр. я є на сайті організації в контактах; або напишіть з офіційної адреси',
  'prevzeti.dokladNapoveda': 'Досить посилання на сторінку, де вас згадано, або офіційної адреси '
      + 'організації, з якої ви напишете.',
  'prevzeti.kontakt': 'Ваш контакт',
  'prevzeti.kontaktPriklad': 'пошта або телефон',
  'prevzeti.dalsi': 'Ще щось',
  'prevzeti.nepovinne': '(необовʼязково)',
  'prevzeti.odeslat': 'Надіслати запит',
  'prevzeti.odesilam': 'Надсилаємо…',
  'prevzeti.vyplnObe': 'Напишіть, яка ваша роль і як це можна перевірити.',
  'prevzeti.prijato': 'Дякуємо. Ми отримали ваш запит і відповімо.',
  'prevzeti.chyba': 'Не вдалося надіслати запит.',
  'prevzeti.upravaTitulek': (p) => `Редагування профілю — ${p.nazev}`,
  'prevzeti.upravaPopis': 'Назви й місця тут навмисно немає: за ними записи шукають і '
      + 'сортують. Якщо вони змінилися, напишіть нам, і ми їх оновимо.',
  'prevzeti.popisPole': 'Опис',
  'prevzeti.email': 'Е-пошта',
  'prevzeti.telefon': 'Телефон',
  'prevzeti.web': 'Сайт',
  'prevzeti.ulozeno': 'Збережено.',
  'prevzeti.ukladam': 'Зберігаємо…',
  'prevzeti.chybaUlozeni': 'Не вдалося зберегти.',
  'prevzeti.druh.organizations': 'організація',
  'prevzeti.druh.events': 'подія',
  'prevzeti.druh.pageants': 'конкурс',

  // ── profil ────────────────────────────────────────────────────────────────
  'profil.upravteUdaje': 'Редагуйте свої дані та налаштування',
  'profil.overeny': 'Підтверджено',
  'profil.neovereny': 'Не підтверджено',
  'profil.overteEmail': 'Підтвердьте свою пошту. Непідтверджений обліковий запис має обмежені права.',
  'profil.emailOdeslan': 'Лист для підтвердження надіслано.',
  'profil.emailChyba': 'Не вдалося надіслати лист',
  'profil.odeslano': 'Надіслано.',
  'profil.overeniOdbornika': 'Підтвердження як фахівця або юриста',
  'profil.pracujeteVOboru': 'Працюєте в цій сфері? Отримайте позначку перевірки.',
  'profil.zadostOdeslana': 'Запит надіслано',
  'profil.pozadatOOvereni': 'Подати запит на перевірку',
  'profil.zadostTitulek': 'Запит на перевірку як фахівця або юриста',
  'profil.zadostPopis': 'Заповніть дані запиту. Модерація його розгляне.',
  'profil.pozadovanaRole': 'Роль, про яку йдеться',
  'profil.roleOdbornik': 'Фахівець',
  'profil.rolePravnik': 'Юрист',
  'profil.specializace': 'Спеціалізація',
  'profil.odkazNaProfil': 'Посилання на професійний профіль',
  'profil.zpravaProAdmina': 'Коротке повідомлення для адміністрації',
  'profil.odesilam': 'Надсилаємо…',
  'profil.odeslatZadost': 'Надіслати запит на перевірку',
  'profil.vyplnteSpecializaci': 'Заповніть свою спеціалізацію',
  'profil.zadostUspech': 'Ваш запит на перевірку надіслано.',
  'profil.zadostChyba': 'Не вдалося надіслати запит',

  // bezpečnost
  'bezp.titulek': 'Безпека',
  'bezp.sifrovaniZapnuto': (p) => `Шифрування повідомлень увімкнено${p.odemceno ? ' і розблоковано' : ' (заблоковано в цій вкладці)'}.`,
  'bezp.sifrovaniVypnuto': 'Ви ще не ввімкнули шифрування повідомлень.',
  'bezp.sifrovaniKde': 'Вмикається й розблоковується на сторінці Повідомлення.',
  'bezp.sifrovaniKdeVypnute': 'Увімкнути можна на сторінці Повідомлення, у будь-якій розмові.',
  'bezp.zmenaHesla': 'Зміна пароля',
  'bezp.zmenaHeslaSifrovani': 'Шифрування ввімкнено, тож зміна пароля перепаковує й ключ до ваших повідомлень. '
      + 'Тому потрібен чинний пароль — без нього ключ не відкрити, і ви втратили б повідомлення.',
  'bezp.stavajiciHeslo': 'Чинний пароль',
  'bezp.noveHeslo': 'Новий пароль',
  'bezp.noveHesloZnovu': 'Повторіть новий пароль',
  'bezp.pozadavky': 'Щонайменше 8 символів, великі й малі літери, цифра і спеціальний символ.',
  'bezp.zmenitHeslo': 'Змінити пароль',
  'bezp.menim': 'Змінюємо…',
  'bezp.hesloNeshoda': 'Нові паролі не збігаються.',
  'bezp.vyplnObe': 'Заповніть обидва паролі.',
  'bezp.stareNesedi': 'Чинний пароль неправильний — ключ до ваших повідомлень було б утрачено, тож нічого не змінено.',
  'bezp.zmenenoSKlicem': 'Пароль змінено. Ключ до ваших повідомлень перепаковано, тож старі повідомлення лишаються читабельними.',
  'bezp.zmeneno': 'Пароль змінено.',
  'bezp.zmenaChyba': 'Не вдалося змінити пароль.',
  'bezp.nepamatujes': 'Не памʼятаєте пароль до ключа?',
  'bezp.zahoditPopis': 'Ви можете відкинути ключ і почати заново. Повідомлення, зашифровані досі, зникнуть назавжди — '
      + 'ніхто їх не прочитає, ми теж ні. Саме тому це безпечно.',
  'bezp.zahodit': 'Відкинути ключі й почати заново',
  'bezp.zahoditPotvrzeni': 'Справді відкинути ключі?\n\nУсі повідомлення, зашифровані досі, зникнуть назавжди — '
      + 'ніхто їх не прочитає, ми теж ні. Робіть це лише тоді, коли не памʼятаєте пароля, '
      + 'яким вмикали шифрування.',
  'bezp.klicSmazan': 'Ключі видалено. Перезавантажте сторінку.',
  'bezp.nepovedlo': 'Не вдалося.',
  'bezp.prohlizecNeumi': 'Цей браузер не підтримує шифрування, яке використовує Bloom.',

  'profil.mujProfil': 'Мій профіль',
  'profil.specializacePriklad': 'напр. психологія, сексологія, право…',
  'profil.zpravaPriklad': 'Наприклад посилання на професійний реєстр або сайт кабінету…',
  'profil.overeniUvod': 'Хочете бути в Bloom перевіреним фахівцем або юристом? Надішліть запит на перевірку. '
      + 'Ваш профіль має відповідати вашій справжній професії.',

  'profil.oborPriklad': 'напр. пластична хірургія, сімейне право…',
  'profil.nepovinnyText': 'Додаткова примітка, необовʼязково…',
  // ── dvoufázové přihlášení ─────────────────────────────────────────────────
  'dvf.titulek': 'Двоетапний вхід',
  'dvf.zapnuto': (p) => `Увімкнено. Залишилося ${p.pocet} резервних кодів.`,
  'dvf.vypnuto': 'Крім пароля ви вводите шестизначний код із застосунку на телефоні.',
  'dvf.chraniA': 'Захищає',
  'dvf.chraniPrihlaseni': 'вхід',
  'dvf.chraniB': ': хто знає ваш пароль, але не має вашого телефона, не увійде.',
  'dvf.nechrani': 'Не захищає зашифровані повідомлення',
  'dvf.nechraniPopis': ' — їх відкриває ваш пароль у вашому власному браузері, без сервера.',
  'dvf.ulozKody': 'Збережіть ці десять резервних кодів',
  'dvf.ulozKodyPopis1': 'Кожен працює один раз, і це єдиний спосіб увійти, якщо ви загубите телефон.',
  'dvf.znovuNeukaze': 'Ніхто вам їх більше не покаже',
  'dvf.ulozKodyPopis2': ' — ми зберігаємо лише їхні відбитки.',
  'dvf.zkopirovat': 'Копіювати',
  'dvf.ulozilaJsem': 'Я їх зберегла',
  'dvf.zkopirovano': 'Скопійовано.',
  'dvf.kopieChyba': 'Скопіювати не вдалося, перепишіть їх вручну.',
  'dvf.zapnout': 'Увімкнути двоетапний вхід',
  'dvf.pripravuji': 'Готуємо…',
  'dvf.nactiKod': 'Відскануйте цей код у застосунку автентифікації — наприклад Google Authenticator, Authy, 1Password чи Aegis.',
  'dvf.qrNejde': 'Не виходить відсканувати QR-код?',
  'dvf.zadejRucne': 'Введіть цей ключ у застосунку вручну:',
  'dvf.opisKod': 'Перепишіть код, який показує застосунок',
  'dvf.zapnoutKratce': 'Увімкнути',
  'dvf.overuji': 'Перевіряємо…',
  'dvf.noveKody': 'Нові резервні коди',
  'dvf.vypnout': 'Вимкнути',
  'dvf.noveKodyPopis': 'Новий набір замінює старий — ваші теперішні резервні коди перестануть діяти.',
  'dvf.kodZAplikace': 'Код із застосунку',
  'dvf.vygenerovat': 'Згенерувати',
  'dvf.vypnutiPopis': 'Щоб вимкнути, потрібні ваш пароль і дійсний код. Обидва навмисно: інакше будь-хто з доступом до відкритого браузера міг би це зняти.',
  'dvf.kodNeboZalozni': 'Код із застосунку або резервний код',
  'dvf.vypinam': 'Вимикаємо…',
  'dvf.vypnoutCele': 'Вимкнути двоетапний вхід',
  'dvf.vypnuto2': 'Двоетапний вхід вимкнено.',
  'dvf.kodNesedi': 'Цей код не підходить.',
  'dvf.nepovedlo': 'Не вдалося.',

  // ── formulář profilu ──────────────────────────────────────────────────────
  'pf.ulozeno': 'Профіль оновлено.',
  'pf.chyba': 'Не вдалося оновити профіль',
  'pf.fotkaNahrana': 'Фото завантажено.',
  'pf.fotkaChyba': 'Не вдалося завантажити зображення',
  'pf.fotkaVelka': 'Зображення завелике (макс. 5 МБ)',
  'pf.oznameniUlozeno': 'Налаштування сповіщень збережено.',
  'pf.oznameniChyba': 'Не вдалося зберегти налаштування',
  'pf.zruseno': 'Ваш профіль видалено',
  'pf.zruseniChyba': 'Не вдалося видалити профіль',
  'pf.zruseniPotvrzeni': 'Справді видалити свій профіль? Це не скасувати, і всі ваші дані буде стерто.',
  'pf.urlFacebook': 'Адреса Facebook має починатися з https://',
  'pf.urlInstagram': 'Адреса Instagram має починатися з https://',
  'pf.urlLinkedin': 'Адреса LinkedIn має починатися з https://',
  'pf.ukladam': 'Зберігаємо…',
  'pf.ulozitOznameni': 'Зберегти налаштування сповіщень',
  'pf.oznameniZpravy': 'Приватні повідомлення',
  'pf.oznameniAdmin': 'Нове повідомлення від адміністрації',
  'pf.oznameniUzivatel': 'Нове повідомлення від іншої людини',
  'pf.oznameniPodpora': 'Новий допис у Взаємній допомозі',
  'pf.oznameniNabidky': 'Пропозиції та запити',

  // odznaky
  'pf.odznakAdmin': 'Адміністрація',
  'pf.odznakPravnik': 'Юрист',
  'pf.odznakSpecialista': 'Перевірений фахівець',
  'pf.odznakClen': 'Перевірена людина зі спільноти',
  'pf.odznakPomocnik': 'Активна допомога',
  'pf.odznakDuveryhodny': 'Людина, якій довіряють',

  // ── galerie ───────────────────────────────────────────────────────────────
  'gal.pridano': 'Фото додано до галереї.',
  'gal.smazano': 'Фото видалено',
  'gal.hesloKratke': 'Пароль галереї має містити щонайменше 4 символи',
  'gal.nahraniChyba': 'Не вдалося завантажити фото',
  'gal.mazaniChyba': 'Не вдалося видалити фото',
  'gal.souborVelky': 'Файл завеликий (макс. 5 МБ)',
  'gal.ulozitNastaveni': 'Зберегти налаштування',
  'gal.hesloPopis': 'Щоб побачити галерею, відвідувачі муситимуть ввести цей пароль.',
  'gal.pridat': 'Додати фото або відео',
  'gal.prazdna': 'У галереї поки що немає фото',

  // ── moje cesta ────────────────────────────────────────────────────────────
  'cesta.kdeJsem': 'Де я зараз?',
  'cesta.popis': 'Поділіться своїм етапом переходу, якщо хочете — або лишіть його собі.',
  'cesta.soukroma': 'Ваш етап приватний',
  'cesta.viditelna': 'Ваш етап бачать інші',
  'cesta.jenTy': 'Ваш етап бачите тільки ви',
  'cesta.mohouNajit': 'Інші можуть знайти вас через «Знайти людей на схожому етапі»',
  'cesta.poznamka': 'Особиста нотатка',
  'cesta.volitelna': '(необовʼязково)',
  'cesta.poznamkaPriklad': 'Усе, чим хочете поділитися або що хочете запамʼятати…',
  'cesta.najitPodobne': 'Знайти людей на схожому етапі',
  'cesta.hledam': 'Шукаємо…',
  'cesta.ulozit': 'Зберегти мій шлях',
  'cesta.ulozeno': 'Ваш шлях збережено.',
  'cesta.vyberteFazi': 'Виберіть етап',
  'cesta.chyba': 'Не вдалося зберегти',

  'pf.socialniSite': 'Соцмережі',
  'pf.avatarFoto': 'Аватар / фото профілю',
  'pf.nahratProfilni': 'Завантажити фото профілю',
  'pf.zrusitProfil': 'Видалити профіль',
  'pf.nastaveniOznameni': 'Налаштування сповіщень',
  'pf.nastaveniOznameniPopis': 'Виберіть, про що хочете отримувати сповіщення.',
  'gal.overEmail': 'Щоб завантажувати фото, спершу підтвердьте свою пошту.',
  'cesta.coMeCeka': 'Що на мене чекає',

  // ── zprávy ────────────────────────────────────────────────────────────────
  'zpr.titulek': 'Повідомлення',
  'zpr.hledatUzivatele': 'Шукати людину…',
  'zpr.zadneKonverzace': 'Поки що немає розмов',
  'zpr.vyhledejteVyse': 'Знайдіть людину вище',
  'zpr.vyberteKonverzaci': 'Виберіть розмову або знайдіть когось',
  'zpr.napisteZpravu': 'Напишіть повідомлення…',
  'zpr.nahravam': 'Записуємо…',
  'zpr.prilozitObrazek': 'Долучити зображення',
  'zpr.hlasovaZprava': 'Голосове повідомлення',
  'zpr.zastavitNahravani': 'Зупинити запис',
  'zpr.obrazek': 'Зображення',
  'zpr.overteEmail': 'Щоб надсилати повідомлення, підтвердьте свою пошту.',
  'zpr.profil': 'Профіль',

  // šifrování
  'zpr.sifrovanaZprava': 'Зашифроване повідомлення',
  'zpr.odemkniNahore': 'Зашифроване повідомлення — розблокуйте повідомлення вище.',
  'zpr.nelzeOtevrit': 'Це зашифроване повідомлення не вдалося відкрити.',

  // hlášky
  'zpr.uzivatelNenalezen': 'Людину не знайдено',
  'zpr.prijemceNenalezen': 'Отримувача не знайдено',
  'zpr.prihlasteZnovu': 'Увійдіть ще раз (сеанс завершився)',
  'zpr.serverNedostupny': 'Сервер недоступний. Перевірте, чи працює бекенд.',
  'zpr.chybaOdeslani': 'Не вдалося надіслати',
  'zpr.souborVelky': 'Файл завеликий (макс. 5 МБ)',
  'zpr.formatNepodporovan': 'Тип файлу не підтримується',
  'zpr.mediaOdeslano': 'Файл надіслано',
  'zpr.mikrofon': 'Мікрофон недоступний',
  'zpr.hlasovkaOdeslana': 'Голосове повідомлення надіслано',
  'zpr.hlasovkaChyba': (p) => `Не вдалося надіслати голосове повідомлення: ${p.detail}`,
  'zpr.smazano': 'Розмову видалено',
  'zpr.smazaniChyba': 'Не вдалося видалити розмову',
  'zpr.smazaniPotvrzeni': 'Вона зникає з вашого списку, разом із вкладеннями. Друга людина зберігає свою копію — '
      + 'із сервера повідомлення зникає повністю лише тоді, коли ви обидві його видалите.',

  // ── šifrování zpráv ───────────────────────────────────────────────────────
  'sif.zadejHeslo': 'Введіть свій пароль.',
  'sif.zapnuto': 'Шифрування ввімкнено.',
  'sif.odemceno': 'Ваші повідомлення розблоковано.',
  'sif.hesloNesedi': 'Цей пароль не підходить.',
  'sif.prohlizecNeumi': 'Цей браузер не підтримує шифрування, яке використовує Bloom. Писати все одно можна, '
      + 'але повідомлення не будуть зашифровані наскрізно.',
  'sif.noveJsouSifrovane': 'Нові повідомлення зашифровані. Ключ маєте лише ви — сервер їх не прочитає.',
  'sif.odemkniZpravy': 'Розблокуйте свої повідомлення',
  'sif.odemkniPopis': 'Ключ живе лише в памʼяті цієї вкладки, тож після перезавантаження сторінки пароль потрібен знову. '
      + 'Ми не можемо його ніде зберігати — тоді це вже не було б шифрування, яке контролюєте тільки ви.',
  'sif.zapniSifrovani': 'Увімкнути шифрування повідомлень',
  'sif.zapniPopis': 'Нові повідомлення шифруються прямо тут, на вашому пристрої. Сервер отримує лише нечитабельні символи '
      + 'і не прочитає їх — навіть якби цього вимагав суд.',
  'sif.pozorA': 'Увага: ключ відкриває ваш пароль.',
  'sif.pozorTucne': 'Якщо ви його забудете, ніхто не прочитає ваші зашифровані повідомлення',
  'sif.pozorB': ' — ми теж ні. У цьому й суть, але це означає, що вам потрібне місце, де його зберігати.',
  'sif.mobilA': 'Увімкнення змінює й спосіб входу: ваш пароль узагалі перестає доходити до сервера, надсилається лише його відбиток.',
  'sif.mobilTucne': 'Старіший мобільний застосунок Bloom тоді не зможе увійти в цей обліковий запис',
  'sif.mobilB': ', доки ми його не оновимо. У браузері все працює далі.',
  'sif.zapnoutSifrovani': 'Увімкнути шифрування',
  'sif.odemknout': 'Розблокувати',
  'sif.tvojeHeslo': 'Ваш пароль до Bloom',
  'sif.prilohaZamcena': 'Зашифроване вкладення — розблокуйте повідомлення вище.',
  'sif.prilohaChyba': 'Не вдалося відкрити вкладення.',
  'sif.priloha': 'Вкладення повідомлення',

  // ── v mém okolí ───────────────────────────────────────────────────────────
  'okoli.vaseLokalita': 'Ваше місце',
  'okoli.nastavtePolohu': 'Вкажіть, де ви, щоб бачити доречні результати',
  'okoli.vyberteVyse': 'Виберіть місце вище, щоб побачити пропозиції та фахівців поруч із вами',
  'okoli.zadniOdbornici': 'У цій місцевості ще немає зареєстрованих фахівців',
  'okoli.zadneNabidky': 'У цій місцевості ще немає пропозицій',
  'okoli.zadniClenove': 'У цій місцевості ще немає нікого зі спільноти',
  'okoli.vytvoritNabidku': 'Створити пропозицію',

  // ── hledání ───────────────────────────────────────────────────────────────
  'hled.hledam': 'Шукаємо:',
  'hled.vysledkyPro': 'Результати пошуку:',
  'hled.nicPro': 'Нічого не знайшли за запитом:',
  'hled.nicZkuste': 'Нічого не знайшли. Спробуйте інше слово.',
  'hled.zkratte': 'Спробуйте коротшу фразу або інше ключове слово.',
  'hled.zadejte': 'Напишіть, що шукаєте, і натисніть Enter',
  'hled.priklady': 'Наприклад: FFS, гормони, імʼя, лікар, документи, операція…',
  'hled.uzivatele': 'Люди',
  'hled.odbornici': 'Транс-дружні фахівці',
  'hled.clanky': 'Правова допомога – статті',
  'hled.otazky': 'Запитання спільноти',
  'hled.nabidky': 'Пропозиції допомоги',
  'hled.prispevky': 'Дописи',
  'hled.recenze': 'Відгуки про фахівців',

  // ── profil člena ──────────────────────────────────────────────────────────
  'up.nenalezen': 'Людину не знайдено',
  'up.oMne': 'Про людину',
  'up.clenOd': 'У Bloom із',
  'up.odznakSpravce': 'Адміністрація',
  'up.odznakPravnik': 'Юрист',
  'up.odznakOdbornik': 'Перевірений фахівець',
  'up.odznakPravnikOvereny': 'Перевірений юрист',
  'up.odznakClen': 'Перевірена людина',
  'up.odznakPomocnik': 'Активна допомога',
  'up.odznakDuveryhodny': 'Викликає довіру',
  // ── zásady komunity ───────────────────────────────────────────────────────
  'kom.zpet': 'Назад до Bloom',
  'kom.oProjektu': 'Bloom виник як безпечний простір спільноти для транс-людей у Чехії — місце, '
      + 'де можна ділитися досвідом, знаходити підтримку, виходити на фахівців і знайомитися. '
      + 'Проєкт тримає спільнота, на волонтерських засадах. Ідеться про делікатність, приватність і взаємну допомогу.',
  'kom.kontaktText': 'Є питання або потрібна допомога? Напишіть. Ми намагаємося відповідати якнайшвидше.',
  'kom.respekt': 'Ми поважаємо одне одного',
  'kom.respektPopis': 'Ми звертаємося до кожної людини тим імʼям і тими займенниками, які вона вживає. Ми поважаємо різні шляхи й досвіди — '
      + 'немає правильного чи неправильного способу бути транс-людиною.',
  'kom.soukromi': 'Ми бережемо приватність одне одного',
  'kom.soukromiPopis': 'Те, чим діляться в Bloom, лишається в Bloom. Не поширюйте інформацію про інших людей без '
      + 'їхньої згоди. Ми поважаємо анонімність.',
  'kom.pomahame': 'Ми допомагаємо одне одному',
  'kom.pomahamePopis': 'Bloom — про взаємну підтримку. Ми ділимося досвідом, допомагаємо й будуємо безпечний простір '
      + 'для кожної людини, яка шукає звʼязок або інформацію.',
  'kom.obtezovani': 'Ми не терпимо переслідувань',
  'kom.obtezovaniPopis': 'Переслідуванню, цькуванню чи ворожим коментарям у Bloom немає місця. Якщо вам незатишно, '
      + 'напишіть адміністрації.',
  'kom.spam': 'Без спаму й реклами',
  'kom.spamPopis': 'Bloom — не торговий майданчик. Не публікуйте непрохану рекламу чи комерційний вміст. '
      + 'Пропозиції та запити — у Взаємній допомозі.',
  'kom.prostor': 'Простір для кожного етапу',
  'kom.prostorPopis': 'Ви не самі, на якому б етапі свого шляху не були. Ми раді людям, які лише думають '
      + 'про перехід, які в його середині і які вже його пройшли — і сприймаємо кожен шлях таким, який він є.',
  'kom.dataPopis': 'Bloom збирає лише ті дані, які потрібні платформі для роботи: вашу пошту, псевдонім і профіль, '
      + 'який ви створюєте самі.',
  'kom.dataTretiStrany': 'Ваші дані не передаються третім сторонам. Платформа не використовує технологій стеження й рекламних мереж.',
  'kom.dataSmazani': 'Ви маєте право попросити видалити ваш обліковий запис і всі повʼязані з ним дані. Напишіть адміністрації.',

  'okoli.podtitulek': 'Знайдіть людей зі спільноти, послуги та фахівців поруч із вами',
  'okoli.cleneVOkoli': (p) => `Люди зі спільноти поблизу: ${p.misto}`,
  'okoli.nabidkyVOkoli': (p) => `Пропозиції допомоги поблизу: ${p.misto}`,
  'okoli.odborniciVOkoli': (p) => `Фахівці поблизу: ${p.misto}`,
  'hled.zobrazitVice': 'Показати більше',
  'kom.titulek': 'Правила спільноти',
  'kom.podtitulek': 'Безпечний простір для всіх',
  'kom.jakNahlasit': 'Як повідомити про проблему',
  'kom.jakNahlasitPopis': 'Якщо ви натрапите на неприйнятну поведінку, є два шляхи: кнопка «Поскаржитися на цю людину» '
      + 'в її профілі або лист адміністрації.',
  'kom.duverne': 'Ваша скарга конфіденційна.',
  'kom.ochranaSoukromi': 'Приватність',
  'obecne.zpetKratce': 'Назад',

  // ── průvodce fází ─────────────────────────────────────────────────────────
  'cesta.nikdoNesdili': 'Поки що ніхто інший зі спільноти не показує цей етап публічно.',
  'cesta.poznamkaFazePriklad': 'Усе, чим хочете поділитися або що хочете запамʼятати про цей етап…',
  'pruvodce.fazeNenalezena': 'Етап не знайдено',
  'pruvodce.pripravujeme': 'Цю частину ми ще готуємо.',
  'pruvodce.krokyJenTy': 'Позначені кроки бачите тільки ви.',
  'pruvodce.nastavitFazi': 'Зробити моїм поточним етапом',
  'pruvodce.fazeNastavena': 'Встановлено як ваш поточний етап',
  'pruvodce.chyba': 'Не вдалося зберегти, спробуйте ще раз',
  'pruvodce.kroku': 'кроків',
  'pruvodce.odborniku': (p) => `${tvary('uk', p.pocet, { one: 'фахівець', few: 'фахівці', many: 'фахівців', other: 'фахівців' })} для цього етапу`,
  'pruvodce.pribehu': (p) => `${tvary('uk', p.pocet, { one: 'історія', few: 'історії', many: 'історій', other: 'історій' })} людей на цьому етапі`,

  // ── obnovení hesla ────────────────────────────────────────────────────────
  'reset.titulek': 'Відновлення пароля',
  'reset.popis': 'Введіть новий пароль до свого облікового запису Bloom.',
  'reset.noveHeslo': 'Новий пароль',
  'reset.noveHesloPriklad': 'Введіть новий пароль',
  'reset.potvrdit': 'Підтвердьте новий пароль',
  'reset.nastavit': 'Зберегти новий пароль',
  'reset.ukladam': 'Зберігаємо…',
  'reset.hotovo': 'Ваш пароль змінено. Тепер можна увійти.',
  'reset.neplatnyOdkaz': 'Це посилання для зміни пароля недійсне.',
  'reset.odkazVyprsel': 'Посилання застаріло або недійсне. Попросіть нове.',
  'reset.chyba': 'Не вдалося змінити пароль.',
  'reset.neshoda': 'Паролі не збігаються.',
  'reset.ztratiPristup': 'втратить доступ',

  'cesta.volitelne': 'Це цілком добровільно. Поділіться своїм етапом переходу, якщо хочете — або лишіть його собі. '
      + 'Ще можна знайти людей на схожому місці шляху.',
  'cesta.hledatVeFazi': 'Знайти людей на цьому етапі:',
  'cesta.jenVerejne': '(лише ті, хто показує це публічно)',
  'pruvodce.zpetNaCestu': 'Назад до Мого шляху',
  'pruvodce.tadyJsi': 'Ви зараз тут',
  'reset.prejitNaPrihlaseni': 'Перейти до входу',
  'reset.sifrovaniVarovani': 'Якщо у вас увімкнене шифрування повідомлень: після зміни пароля ви більше не дістанетеся до старих '
      + 'зашифрованих повідомлень. Їхній ключ відкриває початковий пароль, якого тут ніхто не знає, тож перепакувати його '
      + 'не вийде. Нові повідомлення шифруватимуться далі; старих не прочитає ніхто — і ми теж.',

  // ── veřejná úvodní stránka ────────────────────────────────────────────────
  'uvod.prihlasit': 'Увійти',
  'uvod.vytvoritUcet': 'Створити обліковий запис',
  'uvod.uzMamUcet': 'У мене вже є обліковий запис',
  'uvod.nadpis': 'Безпечний простір для транс-спільноти',
  'uvod.podnadpis': 'Bloom — приватне місце, де можна говорити відверто, знайти транс-дружніх фахівців '
      + 'і проходити перехід серед людей, які знають, як це.',
  'uvod.zdarma': 'Реєстрація безкоштовна. Вміст Bloom відкривається лише після входу.',
  'uvod.kCemuJe': 'Для чого Bloom',
  'uvod.kCemuJe1': 'Шукати в Чехії інформацію про перехід зазвичай означає клікати по розкиданих '
      + 'форумах, застарілих статтях і посиланнях, про які невідомо, кому вірити. А на багато питань '
      + 'усе одно найкраще відповість той, хто це пройшов сам.',
  'uvod.kCemuJe2': 'Bloom збирає це все в одному місці: фахівців, з якими спільнота має добрий досвід, провідник '
      + 'по етапах переходу, правову допомогу і найголовніше — людей, яким можна написати.',
  'uvod.kCemuJe3': 'А оскільки йдеться про речі, які ніхто не хоче розповідати всьому інтернету, Bloom від '
      + 'початку побудовано так, щоб ззовні не було видно взагалі нічого.',
  'uvod.coNajdes': 'Що ви знайдете в Bloom',
  'uvod.coNajdesPopis': 'Вісім частин, які доповнюють одна одну — від практичної допомоги до спільного досвіду.',
  'uvod.soukromiZaklad': 'Приватність — не додаток, а основа',
  'uvod.jakZabezpeceny': 'Як захищений Bloom',
  'uvod.zabezpeceniPopis': 'Дані людей ніде не продаються й не аналізуються. У Bloom не працює жодне рекламне '
      + 'чи аналітичне стеження — жоден чужий скрипт нічого про вас не дізнається.',
  'uvod.coNeumi': 'Чого Bloom не вміє',
  'uvod.metadataTucne': 'хто кому й коли написав',
  'uvod.coNeumiA': 'Сервер завжди знає,',
  'uvod.coNeumiB': ' — без цього він не доставив би повідомлення. Ці метадані не приховає ані наскрізне шифрування, '
      + 'ані Signal. Профілі зашифрувати не можна, бо сервер має показувати їх іншим. '
      + 'А оскільки Bloom — вебзастосунок, він щоразу під час відкриття завантажує код шифрування з нашого сервера '
      + '— хто заволодів би сервером, теоретично міг би підсунути змінений. '
      + 'Від цього захищає лише підписаний застосунок із магазину.',
  'uvod.pridejSe': 'Приєднуйтеся',
  'uvod.pridejSePopis': 'Досить псевдоніма й пошти — своє паспортне імʼя ніде вказувати не треба. Те, що ви про '
      + 'себе напишете, залежить від вас, і це можна будь-коли змінити чи видалити.',

  // co Bloom nabízí
  'uvod.karta.podpora': 'Запропонуйте допомогу або попросіть про неї — від супроводу до лікаря й позиченого одягу до '
      + '«мені треба з кимось поговорити».',
  'uvod.karta.odbornici': 'Сексологія, ендокринологія, хірургія, психотерапія й навіть перукарі. З картою, контактами й досвідом інших.',
  'uvod.karta.pravo': 'Зміна імені, документи, робота, школа. Відповідають люди, які на цьому знаються.',
  'uvod.karta.pruvodce': 'Що чекає на кожному кроці — від перших питань до операцій. З посиланнями на перевірені джерела та фахівців.',
  'uvod.karta.zpravy': 'Напишіть будь-кому зі спільноти. Повідомлення й вкладення лежать на сервері зашифровані.',
  'uvod.karta.zkusenosti': 'Справжні історії людей, які це пройшли. Без цензури й без прикрас.',
  'uvod.karta.aktuality': 'Що відбувається навколо транс-тем у Чехії — зміни законів, події, новини спільноти.',
  'uvod.karta.okoli': 'Хто поруч із вами. Щоб ви знали, що ви не самі, навіть у меншому місті.',

  // zabezpečení
  'uvod.bezp.zvencinic': 'Ззовні не видно взагалі нічого',
  'uvod.bezp.zvencinicText': 'Профілі, історії, фото, пропозиції та зображення в дописах вимагають входу. Без облікового запису '
      + 'сервер не видасть жодних даних про людей — навіть пошуковикам.',
  'uvod.bezp.hesla': 'Ніхто не знає вашого пароля',
  'uvod.bezp.heslaText': 'Зберігається лише відбиток bcrypt, з якого початковий пароль не обчислити. Навіть '
      + 'адміністрація не бачить вашого пароля й не може його надіслати — може лише дати вам поставити новий.',
  'uvod.bezp.sifrovani': 'Повідомлення зашифровані від вас до неї',
  'uvod.bezp.sifrovaniText': 'Коли ви вмикаєте наскрізне шифрування, текст і вкладення шифруються у вашому власному браузері. '
      + 'Ключ відкриває ваш пароль, і він ніколи не залишає ваш пристрій — сервер отримує лише '
      + 'нечитабельні символи й не прочитає їх, навіть якби цього вимагав суд. Без шифрування повідомлення принаймні '
      + 'зашифровані на диску сервера.',
  'uvod.bezp.kontakty': 'Ваші контакти лишаються вашими',
  'uvod.bezp.kontaktyText': 'Пошта й телефон ніколи не потрапляють до інших людей. Ваш етап переходу приватний, доки '
      + 'ви самі його не опублікуєте — а кроки, позначені у Провіднику, бачите тільки ви.',
  'uvod.bezp.smazane': 'Видалене справді видалене',
  'uvod.bezp.smazaneText': 'Розмову можна видалити будь-коли. Коли її видаляють обидві сторони, вона зникає із сервера '
      + 'назавжди, разом із вкладеннями.',
  'uvod.bezp.server': 'Власний сервер у Європі',
  'uvod.bezp.serverText': 'Bloom працює на власному сервері в Європейському Союзі, виключно через HTTPS. База даних недоступна '
      + 'з інтернету. Резервні копії йдуть зашифрованими на інше сховище, і їх відновлення перевірене.',

  'uvod.karta.pruvodceNazev': 'Провідник по переходу',
  'uvod.karta.zpravyNazev': 'Приватні повідомлення',
  // ── vzájemná podpora ──────────────────────────────────────────────────────
  'pod.podtitulek': 'Запропонуйте те, що вмієте, і отримайте допомогу від інших людей зі спільноти',
  'pod.vse': 'Усе',
  'pod.nabidky': 'Пропозиції',
  'pod.poptavky': 'Запити',
  'pod.nabidka': 'Пропозиція',
  'pod.poptavka': 'Запит',
  'pod.celaCR': 'Уся Чехія',
  'pod.celySvet': 'Увесь світ',
  'pod.cesko': 'Чехія',
  'pod.svet': 'Світ',
  'pod.vsechnyTypy': 'Усі категорії',
  'pod.moje': (p) => `Мої (${p.pocet})`,
  'pod.pridat': 'Додати',
  'pod.overEmail': 'Підтвердьте пошту, щоб додати пропозицію',
  'pod.novaPoptavka': 'Новий запит',
  'pod.novaNabidka': 'Нова пропозиція',
  'pod.popisPoptavky': 'Напишіть, що шукаєте і що пропонуєте натомість.',
  'pod.popisNabidky': 'Запропонуйте те, що вмієте, іншим людям зі спільноти.',
  'pod.typPrispevku': 'Тип допису',
  'pod.volitelne': '(необовʼязково)',
  'pod.coNabizim': 'Що пропоную',
  'pod.coNabizimP': 'Що пропоную *',
  'pod.coHledamP': 'Що шукаю *',
  'pod.coHledamVymenou': 'Що шукаю натомість',
  'pod.priklOffer': 'напр. готування, зачіски, переклад…',
  'pod.priklNeed': 'напр. масаж, фотографія…',
  'pod.poptavkaSeZobrazi': 'Ваш запит зʼявиться у вкладці Запити.',
  'pod.nabidkaSeZobrazi': 'Якщо заповните, ваша пропозиція зʼявиться і у вкладці Запити.',
  'pod.popis': 'Опис',
  'pod.popisPriklad': 'Докладніший опис…',
  'pod.oblast': 'Місцевість',
  'pod.lokalita': 'Місце',
  'pod.nechciUvadet': 'Волію не вказувати',
  'pod.kategorie': 'Категорія',
  'pod.ostatni': 'Інше',
  'pod.pridatPoptavku': 'Додати запит',
  'pod.pridatNabidku': 'Додати пропозицію',
  'pod.odpovedetNaPrispevek': 'Відповісти на допис',
  'pod.napisteAutorovi': 'Напишіть приватне повідомлення тому, хто це опублікував.',
  'pod.od': (p) => `Від: ${p.kdo}`,
  'pod.odeslatZpravu': 'Надіслати повідомлення',
  'pod.konceptOdpovedi': (p) => `Вітаю! Мене зацікавила ваша ${p.co} «${p.nazev}». `,
  'pod.konceptPoptavka': 'запит',
  'pod.konceptNabidka': 'пропозиція',
  'pod.zadneMoje': 'У вас ще немає дописів',
  'pod.zadneNalezeny': 'Дописів не знайдено',
  'pod.vytvortePrvni': 'Створіть свою першу пропозицію або запит',
  'pod.zkusteFiltry': 'Спробуйте змінити фільтри або додайте новий допис',
  'pod.expirovano': 'Термін минув',
  'pod.hledam': 'Шукаю',
  'pod.hledamCo': (p) => `Шукаю: ${p.co}`,
  'pod.nabizimCo': (p) => `Пропоную: ${p.co}`,
  'pod.expirovala': 'Термін цієї пропозиції минув. Напишіть адміністрації, щоб її поновити.',
  'pod.odpovedet': 'Відповісти',
  'pod.upravitPrispevek': 'Редагувати допис',
  'pod.upravtePrispevek': 'Відредагуйте свою пропозицію або запит.',
  'pod.nabizimP': 'Пропоную *',
  'pod.hledamPotrebuji': 'Шукаю / потребую',
  'pod.coNabizitePriklad': 'Що ви пропонуєте…',
  'pod.coHledatePriklad': 'Що ви шукаєте…',
  'pod.ulozitZmeny': 'Зберегти зміни',
  'pod.vytvorenoPoptavka': 'Запит створено.',
  'pod.vytvorenoNabidka': 'Пропозицію створено.',
  'pod.chybaVytvorit': 'Не вдалося створити допис',
  'pod.opravduSmazat': 'Видалити цю пропозицію?',
  'pod.smazano': 'Видалено',
  'pod.chybaSmazat': 'Не вдалося видалити',
  'pod.aktualizovano': 'Допис оновлено.',
  'pod.chybaUlozit': 'Не вдалося зберегти',
  'pod.zpravaOdeslana': 'Повідомлення надіслано.',
  'pod.chybaOdeslat': 'Не вдалося надіслати повідомлення',
  'obecne.hledatPriklad': 'Пошук…',
  'obecne.upravit': 'Редагувати',

  // ── odborníci ─────────────────────────────────────────────────────────────
  'odb.podtitulek': 'Знайдіть перевірених фахівців, які допоможуть вам на вашому шляху',
  'odb.hledatPriklad': 'Шукати за іменем або містом…',
  'odb.vsechnyObory': 'Усі напрями',
  'odb.radit': 'Сортувати:',
  'odb.vychozi': 'Типово',
  'odb.nejvyssiHodnoceni': '★ Найвища оцінка',
  'odb.nejnizsiHodnoceni': '★ Найнижча оцінка',
  'odb.zadniNalezeni': 'Фахівців не знайдено',
  'odb.zkusteFiltry': 'Спробуйте змінити фільтри',
  'odb.recenzi': (p) => tvary('uk', p.pocet, { one: 'відгук', few: 'відгуки', many: 'відгуків', other: 'відгуків' }),
  'odb.dostupnyV': 'Доступний у:',
  'odb.otevritVMapach': 'Відкрити на карті',
  'odb.pridatRecenzi': 'Додати відгук',
  'odb.ohodnotte': 'Оцініть свій досвід із цією людиною.',
  'odb.vaseHodnoceni': 'Ваша оцінка *',
  'odb.popisZkusenosti': 'Опишіть свій досвід',
  'odb.popisteZkusenost': 'Опишіть свій досвід…',
  'odb.odeslatRecenzi': 'Надіслати відгук',
  'odb.recenze': (p) => `Відгуки (${p.pocet})`,
  'odb.zadneRecenze': 'Поки що немає відгуків. Будьте першою.',
  'odb.vyberteOdbornika': 'Виберіть фахівця, щоб побачити подробиці й карту',
  'odb.pridatOdbornika': 'Додати фахівця',
  'odb.pridejteOdbornika': 'Додайте до списку нового перевіреного фахівця.',
  'odb.navrhnout': 'Запропонувати фахівця',
  'odb.navrhnetePopis': 'Запропонуйте фахівця на затвердження адміністрацією.',
  'odb.navrhVysvetleni': 'Ваша пропозиція піде до адміністрації. Після затвердження вона зʼявиться у списку.',
  'odb.overEmail': 'Підтвердьте пошту, щоб запропонувати фахівця',
  'odb.jmeno': 'Імʼя *',
  'odb.kategorie': 'Категорія *',
  'odb.popis': 'Опис',
  'odb.popisPriklad': 'Спеціалізація, досвід…',
  'odb.adresa': 'Адреса *',
  'odb.mesto': 'Місто *',
  'odb.kraj': 'Регіон',
  'odb.vyber': 'Виберіть',
  'odb.stat': 'Країна',
  'odb.cesko': 'Чехія',
  'odb.telefon': 'Телефон',
  'odb.web': 'Сайт',
  'odb.odesilam': 'Надсилаємо…',
  'odb.odeslatKeSchvaleni': 'Надіслати на затвердження',
  'odb.recenzePridana': 'Відгук додано.',
  'odb.chybaRecenze': 'Не вдалося додати відгук',
  'odb.odeslanKeSchvaleni': 'Пропозицію надіслано на затвердження.',
  'odb.chybaOdeslat': 'Не вдалося надіслати',
  'odb.pridan': 'Фахівця додано.',
  'odb.chybaPridat': 'Не вдалося додати',
  'odb.polozitOtazku': 'Поставити запитання',
  'odb.novaOtazka': 'Нове запитання до фахівців',
  'odb.naCoSeZeptat': 'Про що ви хочете запитати фахівців?',

  // ── právní poradna ────────────────────────────────────────────────────────
  'prav.podtitulek': 'Інформація та підтримка для транс-спільноти',
  'prav.zpetNaPoradnu': 'Назад до Правової допомоги',
  'prav.clankyAPruvodci': 'Статті та провідники',
  'prav.pridatClanek': 'Додати статтю',
  'prav.novyClanek': 'Нова стаття',
  'prav.vytvorteClanek': 'Напишіть нову статтю до правової частини.',
  'prav.nazev': 'Заголовок *',
  'prav.kategorie': 'Категорія',
  'prav.publikovatIhned': 'Опублікувати одразу',
  'prav.publikovano': 'Опубліковано',
  'prav.obsah': 'Зміст *',
  'prav.obsahPriklad': 'Зміст статті…',
  'prav.zadneClanky': 'У цій категорії немає статей',
  'prav.skryto': 'Приховано',
  'prav.skryt': 'Приховати',
  'prav.publikovat': 'Опублікувати',
  'prav.upravitClanek': 'Редагувати статтю',
  'prav.upravteObsah': 'Відредагуйте зміст цієї статті.',
  'prav.clanekPridan': 'Статтю додано.',
  'prav.chybaPridat': 'Не вдалося додати статтю',
  'prav.clanekUpraven': 'Статтю оновлено.',
  'prav.opravduSmazat': 'Видалити цю статтю?',
  'prav.chybaStav': 'Не вдалося змінити стан',
  'prav.pridatOtazku': 'Додати запитання',
  'prav.novaOtazka': 'Нове запитання',
  'prav.naCoSeZeptat': 'Про що ви хочете запитати?',
  'obecne.vse': 'Усе',

  // ── aktuality ─────────────────────────────────────────────────────────────
  'akt.podtitulek': 'Новини транс-світу',
  'akt.prehratVideo': 'Відтворити відео',
  'akt.obrazekVClanku': 'Зображення у статті',
  'akt.clanekNenalezen': 'Статтю не знайдено',
  'akt.zpetNaAktuality': 'Назад до новин',
  'akt.autor': (p) => `Авторство: ${p.kdo}`,
  'akt.osobniPribeh': 'Особиста історія',
  'akt.upravitClanek': 'Редагувати статтю',
  'akt.komentare': (p) => `Коментарі (${p.pocet})`,
  'akt.zadneKomentare': 'Поки що немає коментарів. Будьте першою.',
  'akt.pridatKomentar': 'Додати коментар…',
  'akt.proKomentovaniOverte': 'Підтвердьте пошту, щоб коментувати.',
  'akt.profil': 'Профіль',
  'akt.prihlasteSeProKomentovani': 'Увійдіть, щоб коментувати.',
  'akt.upravteObsah': 'Відредагуйте зміст цієї статті.',
  'akt.nadpisP': 'Заголовок *',
  'akt.nadpis': 'Заголовок',
  'akt.obsahP': 'Зміст *',
  'akt.textClanku': 'Текст статті…',
  'akt.obrazekUrlNeboSoubor': 'Зображення (адреса або файл)',
  'akt.videoUrlNeboSoubor': 'Відео (адреса або файл)',
  'akt.ukladam': 'Зберігаємо…',
  'akt.novaAktualita': 'Нова новина',
  'akt.sdiletPribeh': 'Поділитися історією',
  'akt.vytvoritAktualitu': 'Написати новину',
  'akt.sdiletZkusenost': 'Поділитися досвідом',
  'akt.napisteAktualitu': 'Напишіть нову новину для спільноти.',
  'akt.podelteSe': 'Поділіться своїм досвідом зі спільнотою.',
  'akt.obrazek': 'Зображення',
  'akt.nahratObrazek': 'Завантажити зображення…',
  'akt.nahratVideo': 'Завантажити відео…',
  'akt.neboUrl': 'або адреса:',
  'akt.textAktuality': 'Текст новини…',
  'akt.sdilejtePribeh': 'Поділіться своєю історією або досвідом зі спільнотою…',
  'akt.nahravam': 'Завантажуємо…',
  'akt.publikovat': 'Опублікувати',
  'akt.zkusenostiTucne': 'Особистий досвід людей зі спільноти.',
  'akt.zkusenostiPopis': 'Ця частина слугує для того, щоб ділитися життєвим досвідом та історіями. Дописи можуть містити текст, зображення чи відео.',
  'akt.sdiletSvujPribeh': 'Поділитися своєю історією',
  'akt.zadneAktuality': 'Новин немає',
  'akt.zadneVKategorii': 'У цій категорії поки що нічого немає',
  'akt.publikovan': 'Допис опубліковано.',
  'akt.chybaPublikovat': 'Не вдалося опублікувати',
  'akt.opravduSmazat': 'Видалити цей допис?',
  'akt.chyba': 'Щось пішло не так',
  'akt.chybaKomentar': 'Не вдалося додати коментар',
  'akt.chybaSmazatKomentar': 'Не вдалося видалити коментар',
  'akt.aktualizovan': 'Допис оновлено.',
  'obecne.smazat': 'Видалити',

  // ── fáze tranzice ─────────────────────────────────────────────────────────
  'faze.thinking': 'Думаю про перехід',
  'faze.thinking.popis': 'Зʼясовую, хто я і який шлях мій.',
  'faze.research': 'Шукаю інформацію',
  'faze.research.popis': 'Читаю, питаю, шукаю джерела та спільноту.',
  'faze.therapist': 'Перший візит до терапевта',
  'faze.therapist.popis': 'Говорю про свій шлях із фахівцем.',
  'faze.hormones': 'Гормональна терапія',
  'faze.hormones.popis': 'Починаю або продовжую гормональну терапію.',
  'faze.documents': 'Зміна документів',
  'faze.documents.popis': 'Займаюся офіційною зміною імені або статі.',
  'faze.cosmetic': 'Зовнішність і догляд',
  'faze.cosmetic.popis': 'Працюю над своєю зовнішністю — волосся, макіяж, стиль.',
  'faze.surgery-thinking': 'Розглядаю операції',
  'faze.surgery-thinking.popis': 'Обмірковую хірургічні можливості.',
  'faze.surgery': 'Після операцій',
  'faze.surgery.popis': 'Маю позаду одну чи більше операцій.',
  'faze.stable': 'Стабільний етап',
  'faze.stable.popis': 'Я там, де хочу бути, і живу своє життя.',
  'faze.individual': 'Мій власний шлях',
  'faze.individual.popis': 'Мій шлях не вкладається в жодну шухлядку — і це нормально.',

  // ── zkušenosti komunity ───────────────────────────────────────────────────
  'zk.podtitulek': 'Тут діляться історіями.',
  'zk.pribehNenalezen': 'Історію не знайдено',
  'zk.zpetNaPribehy': 'Назад до історій',
  'zk.komunita': 'Спільнота',
  'zk.pribeh': 'Історія',
  'zk.upravitPribeh': 'Редагувати історію',
  'zk.upravtePribeh': 'Відредагуйте історію, якою ви поділилися.',
  'zk.textPribehu': 'Текст історії…',
  'zk.fazeTranzice': 'Етап переходу',
  'zk.neuvadet': 'Не вказувати',
  'zk.ukazeSeLidem': 'Історію побачать люди, які читають провідник по цьому етапу.',
  'zk.sdiletPribeh': 'Поділитися історією',
  'zk.overEmail': 'Підтвердьте пошту, щоб поділитися історією',
  'zk.zadnePribehy': 'Поки що немає історій. Будьте першою.',
  'zk.nazevPribehu': 'Заголовок вашої історії…',
  'zk.pribehP': 'Історія *',
  'zk.sdilejteZkusenost': 'Поділіться своїм досвідом зі спільнотою…',
  'zk.chybaNacist': 'Не вдалося завантажити історії',
  'zk.vyplnteNadpis': 'Заповніть заголовок і текст',
  'zk.spatnyOdkaz': 'Посилання на зображення має починатися з http://, https:// або /',
  'zk.sdilen': 'Історією поділилися.',
  'zk.chybaSdilet': 'Не вдалося поділитися',
  'zk.opravduSmazat': 'Видалити цю історію?',
  'zk.smazan': 'Історію видалено',
  'zk.aktualizovan': 'Історію оновлено.',

  // ── rám aplikace ──────────────────────────────────────────────────────────
  'ram.emailNeoveren': 'Ваша пошта ще не підтверджена. Підтвердьте її, будь ласка.',
  'ram.odesilam': 'Надсилаємо…',
  'ram.znovuOdeslat': 'Надіслати ще раз',
  'ram.chceteUpozorneni': 'Хочете отримувати сповіщення про нові повідомлення?',
  'ram.tedNe': 'Зараз ні',
  'ram.paticka': '© 2026 Bloom – приватний простір для транс-спільноти',
  'ram.zasadyKomunity': 'Правила спільноти',
  'ram.prekladNeovereny': 'Цей переклад ще не читав ніхто, хто говорить цією мовою. Якщо щось звучить не так, скажіть нам.',
  'ram.nahlasitProblem': 'Повідомити про проблему',

  // ── otázky komunity ───────────────────────────────────────────────────────
  'ot.spravce': 'Адміністрація',
  'ot.overenyPravnik': 'Перевірений юрист',
  'ot.overenyOdbornik': 'Перевірений фахівець',
  'ot.odznakJinaZeme': (p) => `Цей знак діє лише для: ${p.zeme}`,
  'ot.otazkyKomunity': 'Запитання спільноти',
  'ot.pridatOtazku': 'Додати запитання',
  'ot.novaOtazka': 'Нове запитання',
  'ot.naCoSeZeptat': 'Про що ви хочете запитати?',
  'ot.otazkaSeZobrazi': 'Ваше запитання побачать інші люди зі спільноти, які можуть на нього відповісти.',
  'ot.otazkaP': 'Запитання *',
  'ot.oblastTema': 'Напрям / тема',
  'ot.vseObecna': 'Будь-що (загальне запитання)',
  'ot.odeslatOtazku': 'Надіслати запитання',
  'ot.overEmail': 'Підтвердьте пошту, щоб поставити запитання',
  'ot.zadneOtazky': 'Поки що немає запитань. Будьте першою.',
  'ot.hlasu': (p) => tvary('uk', p.pocet, { one: 'голос', few: 'голоси', many: 'голосів', other: 'голосів' }),
  'ot.odpovedi': (p) => tvary('uk', p.pocet, { one: 'відповідь', few: 'відповіді', many: 'відповідей', other: 'відповідей' }),
  'ot.zadneOdpovedi': 'Поки що немає відповідей.',
  'ot.napisteOdpoved': 'Напишіть відповідь…',
  'ot.jenPravnici': 'На запитання у Правовій допомозі відповідають перевірені юристи та адміністрація.',
  'ot.smazatOtazku': 'Видалити це запитання?',

  // ── cizí profil: nabídky, galerie, nahlášení ──────────────────────────────
  'cp.nabidkyAPoptavky': 'Пропозиції та запити',
  'cp.zadneNabidky': 'Немає пропозицій',
  'cp.napsatZpravu': 'Написати повідомлення',
  'cp.nahlasitUzivatele': 'Поскаржитися на цю людину',
  'cp.nahlasitKoho': (p) => `Поскаржитися: ${p.kdo}`,
  'cp.popisteDuvod': 'Опишіть, чому скаржитеся. Скаргу побачить адміністрація.',
  'cp.zustaneteAnonymni': 'Скаргу отримує адміністрація. Ви лишаєтеся анонімною.',
  'cp.duvodP': 'Причина *',
  'cp.vybertDuvod': 'Виберіть причину…',
  'cp.nevhodneChovani': 'Неприйнятна поведінка',
  'cp.falesnyProfil': 'Фальшивий профіль',
  'cp.jinyProblem': 'Інша проблема',
  'cp.popisVolitelny': 'Опис',
  'cp.volitelny': '(необовʼязково)',
  'cp.popisteSituaci': 'Опишіть ситуацію докладніше…',
  'cp.odeslatNahlaseni': 'Надіслати скаргу',
  'cp.vyberteDuvodChyba': 'Виберіть причину скарги',
  'cp.nahlaseniOdeslano': 'Скаргу надіслано адміністрації',
  'cp.chybaNahlaseni': 'Не вдалося надіслати скаргу',
  'gal.chranenoHeslem': 'Захищено паролем',
  'gal.soukromi': 'Приватність',
  'gal.nahravam': 'Завантажуємо…',
  'gal.pridatFotku': 'Додати фото',
  'gal.nastaveniSoukromi': 'Приватність галереї',
  'gal.verejna': 'Публічна',
  'gal.chranenaHeslem': 'Захищена паролем',
  'gal.nastaveniUlozeno': 'Налаштування галереї збережено',
  'gal.jeChranena': 'Ця галерея захищена паролем',
  'gal.zadneFotky': 'Поки що немає фото. Додайте перше.',
  'gal.otagovat': 'Позначити людину',
  'gal.hledatUzivatele': 'Шукати людину…',
  'gal.odemcena': 'Галерею розблоковано',
  'gal.spatneHeslo': 'Неправильний пароль галереї',
  'gal.fotkaNahrana': 'Фото завантажено.',
  'gal.chybaNahrat': 'Не вдалося завантажити фото',
  'gal.fotkaSmazana': 'Фото видалено',
  'gal.jizOtagovan': 'Цю людину вже позначено',
  'gal.otagovan': (p) => `Позначено: ${p.kdo}`,
  'gal.chybaTag': 'Не вдалося додати позначку',
  'gal.soukromiGalerie': 'Приватність галереї',
  'gal.verejnaGalerie': 'Публічна галерея',

  'ram.povolit': 'Дозволити',
  'ram.oProjektu': 'Про проєкт',
  'ram.kontakt': 'Контакти',

  // ── mapa světa a počty obsahu ─────────────────────────────────────────────
  'mapa.popis': 'Карта світу — натисніть на країну, щоб її відкрити',
  'mapa.priblizit': 'Наблизити',
  'mapa.oddalit': 'Віддалити',
  'mapa.celySvet': 'Назад до всього світу',
  'mapa.chybaNacteni': 'Не вдалося завантажити карту',
  'mapa.chybaZkusteSeznam': 'Не вдалося завантажити карту. Спробуйте список країн нижче.',
  'mapa.teprveRoste': 'Bloom тут лише починає',
  'mapa.napovedaDotyk': 'Тягни, щоб рухати карту; наближай двома пальцями, подвійним дотиком або кнопками. Її не обовʼязково використовувати — нижче є пошук і повний список країн.',
  'obsah.specialists': (p) => tvary('uk', p.pocet, { one: 'фахівець', few: 'фахівці', many: 'фахівців', other: 'фахівців' }),
  'obsah.organizations': (p) => tvary('uk', p.pocet, { one: 'організація', few: 'організації', many: 'організацій', other: 'організацій' }),
  'obsah.events': (p) => tvary('uk', p.pocet, { one: 'подія', few: 'події', many: 'подій', other: 'подій' }),
  'obsah.pageants': (p) => tvary('uk', p.pocet, { one: 'конкурс', few: 'конкурси', many: 'конкурсів', other: 'конкурсів' }),
  'obsah.resources': (p) => tvary('uk', p.pocet, { one: 'матеріал', few: 'матеріали', many: 'матеріалів', other: 'матеріалів' }),
  'obsah.zaznamu': (p) => `${p.pocet} ${tvary('uk', p.pocet, { one: 'запис', few: 'записи', many: 'записів', other: 'записів' })}`,

  // ── výběr domovské země ───────────────────────────────────────────────────
  'domov.otazka': 'Де ваш дім?',
  'domov.popis': 'За цим Bloom покаже вам те, що поруч. Дивитися можна будь-яку країну — вашої '
      + 'країни це не змінить. Ніде не публікується і будь-коли можна змінити.',
  'domov.preskocit': 'Пропустити',
  'domov.najitZemi': 'Знайти країну…',
  'domov.nicNeodpovida': 'Нічого не знайдено. Спробуйте інакше.',
  'domov.klikniDoMapy': 'Ще можна просто натиснути на країну на карті вище.',

  // ── vyhledávání v liště ───────────────────────────────────────────────────
  'typ.posts': 'Допис',
  'typ.users': 'Людина',
  'typ.specialists': 'Фахівець',
  'typ.services': 'Пропозиція',
  'typ.articles': 'Правова допомога',
  'typ.questions': 'Запитання спільноти',
  'typ.reviews': 'Відгук про фахівця',
  'nav.emailNeoveren': 'Пошту не підтверджено',
  'nav.neovereny': 'Не підтверджено',

  // ── hlášení problému ──────────────────────────────────────────────────────
  'chyba.neco': 'Щось не працює',
  'chyba.navrh': 'Пропозиція покращення',
  'chyba.bezpecnost': 'Проблема з безпекою',
  'chyba.jiny': 'Щось інше',
  'chyba.vyberteTyp': 'Виберіть тип проблеми',
  'chyba.popisteProsim': 'Опишіть проблему',
  'chyba.odeslano': 'Повідомлення надіслано, дякуємо!',
  'chyba.chybaOdeslat': 'Не вдалося надіслати повідомлення',
  'chyba.napisteNam': 'Напишіть нам, що сталося — це допоможе це виправити.',
  'chyba.typProblemu': 'Тип проблеми',
  'chyba.popisProblemu': 'Що сталося',
  'chyba.popisPriklad': 'Опишіть, що сталося, чого ви очікували і що сталося натомість…',
  'chyba.priloha': 'Автоматично додаємо: поточну сторінку, час і дані про ваш браузер.',
  'chyba.odeslatHlaseni': 'Надіслати повідомлення',

  // ── editor textu ──────────────────────────────────────────────────────────
  'ed.napisteObsah': 'Напишіть зміст…',
  'ed.tucne': 'Жирний (Ctrl+B)',
  'ed.kurziva': 'Курсив (Ctrl+I)',
  'ed.odrazky': 'Маркований список',
  'ed.vlozitOdkaz': 'Вставити посилання',
  'ed.vlozitTabulku': 'Вставити таблицю',
  'ed.radky': 'Рядки',
  'ed.sloupce': 'Стовпці',
  'ed.vlozit': 'Вставити',
  'ed.barva.cerna': 'Чорний',
  'ed.barva.seda': 'Сірий',
  'ed.barva.fialova': 'Фіолетовий',
  'ed.barva.ruzova': 'Рожевий',
  'ed.barva.modra': 'Синій',
  'ed.barva.zelena': 'Зелений',
  'ed.barva.cervena': 'Червоний',
  'ed.barva.oranzova': 'Помаранчевий',

  // ── ověření e-mailu a přihlášení přes jiné služby ─────────────────────────
  'over.neplatnyOdkaz': 'Це посилання для підтвердження недійсне.',
  'over.hotovo': 'Вашу пошту підтверджено.',
  'over.odkazVyprsel': 'Посилання для підтвердження недійсне або застаріле.',
  'over.overuji': 'Підтверджуємо пошту…',
  'over.cekejte': 'Зачекайте, будь ласка.',
  'over.overen': 'Пошту підтверджено.',
  'over.plnyPristup': 'Тепер у вас повний доступ до всього в Bloom.',
  'over.prejitNaBloom': 'Перейти до Bloom',
  'over.selhalo': 'Підтвердження не вдалося',
  'over.zpetNaPrihlaseni': 'Назад до входу',
  'oauth.ucetNenalezen': 'Обліковий запис не знайдено',
  'oauth.neexistujeGoogle': 'Для цього облікового запису Google немає запису в Bloom. Спершу зареєструйтеся.',
  'oauth.neexistujeFacebook': 'Для цього облікового запису Facebook немає запису в Bloom. Спершу зареєструйтеся.',
  'oauth.registrovatGoogle': 'Зареєструватися через Google',
  'oauth.registrovatFacebook': 'Зареєструватися через Facebook',
  'oauth.prihlasujiGoogle': 'Вхід через Google…',
  'oauth.prihlasujiFacebook': 'Вхід через Facebook…',
  'oauth.facebookSelhalo': 'Не вдалося увійти через Facebook',

  // ── drobnosti ─────────────────────────────────────────────────────────────
  'obecne.nacitam': 'Завантаження…',
  'obecne.nezadano': '— не вказано —',
  'obecne.neplatnaHodnota': 'Це значення недійсне.',
  'obecne.strankovani': 'Сторінки',
  'navrh.doplnteNazev': 'Заповніть назву.',
  'navrh.vyberteZemi': 'Виберіть країну.',
  'navrh.doplnte': (p) => `Заповніть: ${p.co}.`,
  'kat.overenoZaznam': 'Перевірено, що запис відповідає дійсності',
  'kat.prihlaskyDo': (p) => `Заявки до ${p.datum}`,

  'up.odznakAdmin': 'Адмін',

  'profil.zalozkaProfil': 'Профіль',
  'profil.zalozkaGalerie': 'Галерея',
  'pf.lokalita': 'Місце',

  'cesta.legendaBarev': 'Легенда кольорів',

  'hled.pocetVysledku': (p) => `(${p.pocet} ${tvary('uk', p.pocet, { one: 'результат', few: 'результати', many: 'результатів', other: 'результатів' })})`,

  // ── avataři ───────────────────────────────────────────────────────────────
  'avatar.fem-pink': 'Довге світле волосся',
  'avatar.fem-lavender': 'Фіолетове волосся',
  'avatar.fem-peach': 'Каре з чубчиком',
  'avatar.fem-dark': 'Довге темне волосся',
  'avatar.fem-straight': 'Руде волосся',
  'avatar.fem-ponytail': 'Хвіст',
  'avatar.masc-blue': 'Коротке світле волосся',
  'avatar.masc-teal': 'Скуйовджене волосся',
  'avatar.masc-gray': 'Сиве волосся',
  'avatar.masc-short': 'Їжачок',
  'avatar.nb-mint': 'Мʼятне волосся',
  'avatar.nb-lilac': 'Високий пучок',
  'avatar.nb-curly': 'Короткі кучері',
  'avatar.nb-sage': 'Волосся до плечей',
  'avatar.nb-mohawk': 'Ірокез',
  'avatar.nb-undercut': 'Андеркат',
  'avatar.nb-shaved': 'Поголена голова',
  'avatar.nb-glasses': 'Окуляри',
  'avatar.animal-cat': 'Кіт',
  'avatar.animal-fox': 'Лисиця',
  'avatar.animal-rabbit': 'Кролик',
  'avatar.sym-flower': 'Квітка',
  'avatar.sym-butterfly': 'Метелик',
  'avatar.sym-star': 'Зірка',
  'avatar.custom': 'Завантажити власне фото',

  // ── odhlášení po nečinnosti ───────────────────────────────────────────────
  'odhl.necinnost': 'Ми вийшли з облікового запису після часу без дії.',
  'odhl.necinnostPopis': 'Bloom не залишає вхід відкритим, коли поруч нікого немає.',
  'odhl.zaChvili': 'За хвилину ми вас відʼєднаємо',
  'odhl.zaChviliPopis': 'Торкніться екрана чи клавіатури будь-коли, і ви лишитеся у своєму записі.',

  'reg.avatarSymboly': 'Символи',

  'avatar.fem-bun': 'Пучок',
  'avatar.masc-navy': 'Густа борода',
  'avatar.masc-brown': 'Проділ збоку',
  'avatar.masc-goatee': 'Борідка',
  'avatar.nb-freckles': 'Ластовиння',
  'avatar.animal-panda': 'Панда',
  'avatar.animal-owl': 'Сова',
  'avatar.sym-rainbow': 'Веселка',
  'avatar.sym-heart': 'Серце',
  'avatar.sym-lotus': 'Лотос (Bloom)',

  'reg.potvrditHeslo': 'Підтвердьте пароль',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vytvorit': 'Створити',
  'obecne.sdilet': 'Поділитися',
  'obecne.opravneni': 'Дозвіл',
  'obecne.pristupGalerie': 'Щоб завантажити фото, нам потрібен доступ до галереї.',
  'obecne.vsechnyRegiony': 'Усі регіони',
  'obecne.cesko': 'Чехія',
  'obecne.odbornici': 'Фахівці',
  'obecne.zadnaZprava': 'Немає повідомлень',
  'ucet.vyplnteEmailHeslo': 'Введи e-mail і пароль',
  'ucet.spatneUdaje': 'Неправильний e-mail або пароль',
  'ucet.googleSelhalo': 'Не вдалося увійти через Google',
  'ucet.skrytHeslo': 'Сховати пароль',
  'ucet.emailOveren': 'Твій e-mail підтверджено.',
  'ucet.emailPriklad': 'ти@email.ua',
  'ucet.overeniSelhalo': 'Перевірку не пройдено.',
  'ucet.overeniSelhaloZnovu': 'Перевірку не пройдено. Спробуй ще раз.',
  'ucet.komunitniHesloPovinne': 'Пароль спільноти обов’язковий',
  'ucet.zadejteKomunitniHeslo': 'Введи пароль спільноти…',
  'ucet.komunitniHesloPopis': 'Bloom — це приватний простір. Пароль тобі може дати хтось зі спільноти.',
  'ucet.prezdivkaMin3': 'Ім’я має містити щонайменше 3 символи',
  'ucet.vyplntePrezdivku': 'Введи ім’я',
  'ucet.vasePrezdivka': 'Твоє ім’я',
  'ucet.profilNeulozen': 'Не вдалося зберегти профіль',
  'ucet.anoZrusitProfil': 'Так, видалити профіль',
  'heslo.min8': 'Пароль має містити щонайменше 8 символів',
  'heslo.maleP': 'Пароль має містити малу літеру',
  'heslo.velkeP': 'Пароль має містити велику літеру',
  'heslo.cislo': 'Пароль має містити цифру',
  'heslo.specialni': 'Пароль має містити спеціальний символ',
  'heslo.specialniPriklad': 'Пароль має містити спеціальний символ (!@#$%)',
  'heslo.napoveda': 'Мін. 8 символів, велика літера, цифра, спецсимвол',
  'profil.oSobe': 'Коротко про себе…',
  'profil.zajmenaOna': 'вона/її',
  'profil.zajmenaJine': 'інше',
  'profil.doplnujiciText': 'Необов’язкова примітка…',
  'profil.prikladOboru': 'напр. пластична хірургія, сімейне право…',
  'komunita.soukromiNadpis': 'Ми захищаємо приватність',
  'komunita.soukromiText': 'Те, чим ділишся в Bloom, залишається в Bloom.',
  'komunita.podporaText': 'Bloom — це про взаємну підтримку.',
  'komunita.neniObchod': 'Bloom — не торговий майданчик.',
  'komunita.zadneObtezovani': 'Будь-яким домаганням у Bloom немає місця.',
  'komunita.oslovovani': 'Звертаємось до кожного ім’ям і займенниками, які він уживає.',
  'komunita.jakakolivEtapa': 'Хоч би де ти був на своєму шляху.',
  'prav.kategZdravi': 'Здоров’я',
  'prav.kategPravni': 'Правове',
  'prav.kategSocialni': 'Соціальне',
  'ot.chybaOdpoved': 'Не вдалося надіслати відповідь.',
  'ot.chybaOtazka': 'Не вдалося додати запитання.',
  'zk.napisteKomentar': 'Напиши коментар…',
  'zpr.chybaHlasova': 'Не вдалося завантажити голосове повідомлення. Сервер:',
  'zpr.chybaObrazek': 'Не вдалося завантажити зображення. Сервер:',
  'pod.nabizim': 'Пропоную',
  'pod.coHledate': 'Що ти шукаєш? (напр. масаж, фотографія…)',
  'pod.coNabizite': 'Що ти пропонуєш? (напр. готування, зачіски…)',
  'pod.lokalitaVolitelna': 'Місце (необов’язково)',
  'pod.podrobnejsiPopis': 'Докладніший опис *',
  'pod.vyplnteHledate': 'Напиши, що шукаєш.',
  'pod.vyplnteNabizite': 'Напиши, що пропонуєш.',
  'pod.vyplntePopis': 'Додай опис.',
  'pod.zadnePrispevky': 'У тебе ще немає дописів. Створи пропозицію або запит.',
  'svet.vybratZemi': 'Обрати країну',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ot.pridat': 'Поставити запитання',
  'ot.nadpis': 'Запитання та відповіді',
  'zk.pridat': 'Додати історію',
  'zk.novy': 'Нова історія',
  'zk.smazat': 'Видалити історію',
  'zk.zadne': 'Історій ще немає. Поділися першою.',
  'akt.zadne': 'Новин поки немає.',
  'nav.clanky': 'Статті',
  'ucet.emailOdeslan': 'E-mail надіслано',
  'ucet.komunitniHeslo': 'Пароль спільноти',
  'ucet.nemateUcet': 'Немає облікового запису? Зареєструйся',
  'ucet.muzetePrihlasit': 'Тепер можеш увійти.',
  'ucet.zapomenutePopis': 'Введи e-mail і ми надішлемо посилання для відновлення пароля.',
  'profil.oMneVolitelne': 'Про мене (необов’язково)',
  'profil.prezdivka': 'Ім’я',
  'profil.telefonVolitelne': 'Телефон (необов’язково)',
  'cesta.poznamkaVolitelna': 'Особиста нотатка (необов’язково)',
  'okoli.vyberteLokalitu': 'Обери місце вище',
  'hled.nadpis': 'Пошук',
  'hled.popis': 'Шукай по всьому застосунку — люди, статті, історії, відгуки…',
  'hled.min2': 'Введи щонайменше 2 символи для пошуку',
  'pod.vsechnySluzby': 'Усі послуги',
  'domu.clenoveKomunity': 'Учасники спільноти',
  'zpr.zadneKonverzaceHledat': 'Розмов ще немає. Знайди когось вище.',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'reg.zajmenaOn': 'він/його',
  'reg.zajmenaOni': 'вони/їх',
  'reg.zajmenaOno': 'воно/його',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.smazatFotku': 'Видалити фото',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.nastavteHeslo': 'Встанови пароль для галереї',
  'reg.min3znaky': 'Мін. 3 символи',
  'reg.zopakujteHeslo': 'Повтори пароль',
  'hled.vBloom': 'Шукати в Bloom…',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'profil.upravitProfil': 'Редагувати профіль',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vybratRegion': 'Обрати регіон',
  'obecne.region': 'Регіон',
  'gal.heslemChranena': 'Захищена паролем',
  'gal.hesloGalerie': 'Пароль галереї',
  'reset.nastavitHeslo': 'Встановити пароль',
  'reset.hesloObnoveno': 'Пароль відновлено.',
  'profil.nenalezen': 'Профіль не знайдено',
  'obecne.nebo': 'або',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'auth.dvfNapoveda': 'Відкрий застосунок з одноразовими кодами й перепиши шість цифр для Bloom. Замість них можна ввести один із резервних кодів.',
  'auth.sifrovaniNapoveda': 'Якщо ти увімкнув шифрування повідомлень у вебі, застосунок поки що не ввійде до такого облікового запису. Скористайся bloomapp.cz у браузері.',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ucet.zobrazitHeslo': 'Показати пароль',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.opravduSmazat': 'Видалити це фото?',
  'dvf.zadejteKod': 'Введи код із застосунку',
  'sif.odemknoutAplikaci': 'Розблокувати застосунок',
  'profil.odeslatZnovu': 'Надіслати ще раз',
};

export default uk;
